"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("./util");
var CatalogUrlParamKeys;
(function (CatalogUrlParamKeys) {
    CatalogUrlParamKeys.column = 'column';
    CatalogUrlParamKeys.embeddedDataSource = 'embeddedDataSource';
    CatalogUrlParamKeys.field = 'field';
    CatalogUrlParamKeys.order = 'order';
    CatalogUrlParamKeys.outputStep = 'outputStep';
    CatalogUrlParamKeys.search = 'search';
    CatalogUrlParamKeys.table = 'table';
})(CatalogUrlParamKeys = exports.CatalogUrlParamKeys || (exports.CatalogUrlParamKeys = {}));
function tagParam(tag) {
    return 'tag=' + util_1.encodeUriQuery(tag);
}
function deviceTypeParam(deviceType) {
    return ':device=' + util_1.encodeUriQuery(deviceType);
}
var SiteUrls = /** @class */ (function () {
    function SiteUrls(config) {
        if (config.queryString && config.queryString.length > 0) {
            // Prepend a '?' if missing
            this.queryString = (config.queryString[0] === '?' ? '' : '?') + config.queryString;
        }
        else {
            this.queryString = '';
        }
        this.sitePrefix = SiteUrls.makeSitePrefix(config.siteUrlName);
        this.vizClientSitePrefix = SiteUrls.makeVizClientSitePrefix(config.siteUrlName);
    }
    // Returns a copy of SiteUrls modified for a different siteUrlName
    SiteUrls.prototype.forSiteName = function (siteName) {
        return new SiteUrls({
            siteUrlName: siteName,
            queryString: this.queryString
        });
    };
    // The full url is prefixed by the query string and puts the path in the hash.
    SiteUrls.prototype.fullUrl = function (path) {
        return "/" + this.queryString + "#" + path;
    };
    // A site path is a path starting with /site/<siteUrlName>
    SiteUrls.prototype.sitePath = function (path) {
        return "" + this.sitePrefix + path;
    };
    SiteUrls.makeSitePrefix = function (siteUrlName) {
        return siteUrlName && siteUrlName.length > 0 ? "/site/" + siteUrlName : '';
    };
    SiteUrls.prototype.defaultUrl = function () {
        return this.fullUrl(this.defaultPath());
    };
    SiteUrls.prototype.defaultPath = function () {
        return this.sitePath('/');
    };
    // Data Catalog
    SiteUrls.prototype.catalogUrl = function () {
        return this.fullUrl(this.catalogPath());
    };
    SiteUrls.prototype.catalogPath = function () {
        return this.sitePath(SiteUrls.catalogPart());
    };
    SiteUrls.catalogPart = function () {
        return '/catalog';
    };
    // Data Catalog shared parts
    SiteUrls.columnsPart = function () {
        return '/columns';
    };
    SiteUrls.dashboardsPart = function () {
        return '/dashboards';
    };
    SiteUrls.databasesPart = function () {
        return '/databases';
    };
    SiteUrls.downstreamPart = function () {
        return '/downstream';
    };
    SiteUrls.fieldsPart = function () {
        return '/fields';
    };
    SiteUrls.lineagePart = function () {
        return '/lineage';
    };
    SiteUrls.lineageMetricsPart = function () {
        return '/metrics';
    };
    SiteUrls.ownersPart = function () {
        return '/owners';
    };
    SiteUrls.sheetsPart = function () {
        return '/sheets';
    };
    SiteUrls.tablesPart = function () {
        return '/tables';
    };
    SiteUrls.upstreamPart = function () {
        return '/upstream';
    };
    // Table
    SiteUrls.prototype.catalogTablesUrl = function () {
        return this.fullUrl(this.catalogTablesPath());
    };
    SiteUrls.prototype.catalogTablesPath = function () {
        return this.sitePath(SiteUrls.catalogTablesPart());
    };
    SiteUrls.catalogTablesPart = function () {
        return "" + SiteUrls.catalogPart() + SiteUrls.tablesPart();
    };
    SiteUrls.prototype.catalogTableUrl = function (tableId) {
        return this.fullUrl(this.catalogTablePath(tableId));
    };
    SiteUrls.prototype.catalogTablePath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTablePart(tableId));
    };
    SiteUrls.catalogTablePart = function (tableId) {
        return SiteUrls.catalogTablesPart() + "/" + tableId;
    };
    SiteUrls.prototype.catalogTableColumnsUrl = function (tableId) {
        return this.fullUrl(this.catalogTableColumnsPath(tableId));
    };
    SiteUrls.prototype.catalogTableColumnsPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableColumnsPart(tableId));
    };
    SiteUrls.catalogTableColumnsPart = function (tableId) {
        return "" + SiteUrls.catalogTablePart(tableId) + SiteUrls.columnsPart();
    };
    SiteUrls.prototype.catalogTableColumnUrl = function (tableId, columnId) {
        return this.fullUrl(this.catalogTableColumnPath(tableId, columnId));
    };
    SiteUrls.prototype.catalogTableColumnPath = function (tableId, columnId) {
        return this.sitePath(SiteUrls.catalogTableColumnPart(tableId, columnId));
    };
    SiteUrls.catalogTableColumnPart = function (tableId, columnId) {
        return "" + SiteUrls.catalogTablePart(tableId) + SiteUrls.columnsPart() + "/" + columnId;
    };
    SiteUrls.prototype.catalogTableUpstreamDatabasesUrl = function (tableId) {
        return this.fullUrl(this.catalogTableUpstreamDatabasesPath(tableId));
    };
    SiteUrls.prototype.catalogTableUpstreamDatabasesPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableUpstreamDatabasesPart(tableId));
    };
    SiteUrls.catalogTableUpstreamDatabasesPart = function (tableId) {
        return "" + SiteUrls.catalogTablePart(tableId) + SiteUrls.upstreamPart() + SiteUrls.databasesPart();
    };
    SiteUrls.prototype.catalogTableUpstreamTablesUrl = function (tableId) {
        return this.fullUrl(this.catalogTableUpstreamTablesPath(tableId));
    };
    SiteUrls.prototype.catalogTableUpstreamTablesPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableUpstreamTablesPart(tableId));
    };
    SiteUrls.catalogTableUpstreamTablesPart = function (tableId) {
        return "" + SiteUrls.catalogTablePart(tableId) + SiteUrls.upstreamPart() + SiteUrls.tablesPart();
    };
    SiteUrls.prototype.catalogTableUpstreamFlowsUrl = function (tableId) {
        return this.fullUrl(this.catalogTableUpstreamFlowsPath(tableId));
    };
    SiteUrls.prototype.catalogTableUpstreamFlowsPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableUpstreamFlowsPart(tableId));
    };
    SiteUrls.catalogTableUpstreamFlowsPart = function (tableId) {
        return "" + SiteUrls.catalogTablePart(tableId) + SiteUrls.upstreamPart() + SiteUrls.flowsPart();
    };
    SiteUrls.prototype.catalogTableUpstreamDatasourcesUrl = function (tableId) {
        return this.fullUrl(this.catalogTableUpstreamDatasourcesPath(tableId));
    };
    SiteUrls.prototype.catalogTableUpstreamDatasourcesPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableUpstreamDatasourcesPart(tableId));
    };
    SiteUrls.catalogTableUpstreamDatasourcesPart = function (tableId) {
        return "" + SiteUrls.catalogTablePart(tableId) + SiteUrls.upstreamPart() + SiteUrls.datasourcesPart();
    };
    SiteUrls.prototype.catalogTableDownstreamDatabasesUrl = function (tableId) {
        return this.fullUrl(this.catalogTableDownstreamDatabasesPath(tableId));
    };
    SiteUrls.prototype.catalogTableDownstreamDatabasesPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableDownstreamDatabasesPart(tableId));
    };
    SiteUrls.catalogTableDownstreamDatabasesPart = function (tableId) {
        return "" + SiteUrls.catalogTablePart(tableId) + SiteUrls.downstreamPart() + SiteUrls.databasesPart();
    };
    SiteUrls.prototype.catalogTableDownstreamTablesUrl = function (tableId) {
        return this.fullUrl(this.catalogTableDownstreamTablesPath(tableId));
    };
    SiteUrls.prototype.catalogTableDownstreamTablesPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableDownstreamTablesPart(tableId));
    };
    SiteUrls.catalogTableDownstreamTablesPart = function (tableId) {
        return "" + SiteUrls.catalogTablePart(tableId) + SiteUrls.downstreamPart() + SiteUrls.tablesPart();
    };
    SiteUrls.prototype.catalogTableDownstreamFlowsUrl = function (tableId) {
        return this.fullUrl(this.catalogTableDownstreamFlowsPath(tableId));
    };
    SiteUrls.prototype.catalogTableDownstreamFlowsPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableDownstreamFlowsPart(tableId));
    };
    SiteUrls.catalogTableDownstreamFlowsPart = function (tableId) {
        return "" + SiteUrls.catalogTablePart(tableId) + SiteUrls.downstreamPart() + SiteUrls.flowsPart();
    };
    SiteUrls.prototype.catalogTableDownstreamDatasourcesUrl = function (tableId) {
        return this.fullUrl(this.catalogTableDownstreamDatasourcesPath(tableId));
    };
    SiteUrls.prototype.catalogTableDownstreamDatasourcesPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableDownstreamDatasourcesPart(tableId));
    };
    SiteUrls.catalogTableDownstreamDatasourcesPart = function (tableId) {
        return "" + SiteUrls.catalogTablePart(tableId) + SiteUrls.downstreamPart() + SiteUrls.datasourcesPart();
    };
    SiteUrls.prototype.catalogTableDownstreamWorkbooksUrl = function (tableId) {
        return this.fullUrl(this.catalogTableDownstreamWorkbooksPath(tableId));
    };
    SiteUrls.prototype.catalogTableDownstreamWorkbooksPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableDownstreamWorkbooksPart(tableId));
    };
    SiteUrls.catalogTableDownstreamWorkbooksPart = function (tableId) {
        return "" + SiteUrls.catalogTablePart(tableId) + SiteUrls.downstreamPart() + SiteUrls.workbooksPart();
    };
    SiteUrls.prototype.catalogTableDownstreamDashboardsUrl = function (tableId) {
        return this.fullUrl(this.catalogTableDownstreamDashboardsPath(tableId));
    };
    SiteUrls.prototype.catalogTableDownstreamDashboardsPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableDownstreamDashboardsPart(tableId));
    };
    SiteUrls.catalogTableDownstreamDashboardsPart = function (tableId) {
        return "" + SiteUrls.catalogTablePart(tableId) + SiteUrls.downstreamPart() + SiteUrls.dashboardsPart();
    };
    SiteUrls.prototype.catalogTableDownstreamSheetsUrl = function (tableId) {
        return this.fullUrl(this.catalogTableDownstreamSheetsPath(tableId));
    };
    SiteUrls.prototype.catalogTableDownstreamSheetsPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableDownstreamSheetsPart(tableId));
    };
    SiteUrls.catalogTableDownstreamSheetsPart = function (tableId) {
        return "" + SiteUrls.catalogTablePart(tableId) + SiteUrls.downstreamPart() + SiteUrls.sheetsPart();
    };
    SiteUrls.prototype.catalogTableDownstreamMetricsUrl = function (tableId) {
        return this.fullUrl(this.catalogTableDownstreamMetricsPath(tableId));
    };
    SiteUrls.prototype.catalogTableDownstreamMetricsPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableDownstreamMetricsPart(tableId));
    };
    SiteUrls.catalogTableDownstreamMetricsPart = function (tableId) {
        return "" + SiteUrls.catalogTablePart(tableId) + SiteUrls.downstreamPart() + SiteUrls.lineageMetricsPart();
    };
    SiteUrls.prototype.catalogTableDownstreamOwnersUrl = function (tableId) {
        return this.fullUrl(this.catalogTableDownstreamOwnersPath(tableId));
    };
    SiteUrls.prototype.catalogTableDownstreamOwnersPath = function (tableId) {
        return this.sitePath(SiteUrls.catalogTableDownstreamOwnersPart(tableId));
    };
    SiteUrls.catalogTableDownstreamOwnersPart = function (tableId) {
        return "" + SiteUrls.catalogTablePart(tableId) + SiteUrls.downstreamPart() + SiteUrls.ownersPart();
    };
    // Database
    SiteUrls.prototype.catalogDatabasesUrl = function () {
        return this.fullUrl(this.catalogDatabasesPath());
    };
    SiteUrls.prototype.catalogDatabasesPath = function () {
        return this.sitePath(SiteUrls.catalogDatabasesPart());
    };
    SiteUrls.catalogDatabasesPart = function () {
        return "" + SiteUrls.catalogPart() + SiteUrls.databasesPart();
    };
    SiteUrls.prototype.catalogDatabaseUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabasePath(databaseId));
    };
    SiteUrls.prototype.catalogDatabasePath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabasePart(databaseId));
    };
    SiteUrls.catalogDatabasePart = function (databaseId) {
        return SiteUrls.catalogDatabasesPart() + "/" + databaseId;
    };
    SiteUrls.prototype.catalogDatabaseTablesUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseTablesPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseTablesPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseTablesPart(databaseId));
    };
    SiteUrls.catalogDatabaseTablesPart = function (databaseId) {
        return "" + SiteUrls.catalogDatabasePart(databaseId) + SiteUrls.tablesPart();
    };
    SiteUrls.prototype.catalogDatabaseUpstreamDatabasesUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseUpstreamDatabasesPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseUpstreamDatabasesPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseUpstreamDatabasesPart(databaseId));
    };
    SiteUrls.catalogDatabaseUpstreamDatabasesPart = function (databaseId) {
        return "" + SiteUrls.catalogDatabasePart(databaseId) + SiteUrls.upstreamPart() + SiteUrls.databasesPart();
    };
    SiteUrls.prototype.catalogDatabaseUpstreamTablesUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseUpstreamTablesPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseUpstreamTablesPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseUpstreamTablesPart(databaseId));
    };
    SiteUrls.catalogDatabaseUpstreamTablesPart = function (databaseId) {
        return "" + SiteUrls.catalogDatabasePart(databaseId) + SiteUrls.upstreamPart() + SiteUrls.tablesPart();
    };
    SiteUrls.prototype.catalogDatabaseUpstreamFlowsUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseUpstreamFlowsPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseUpstreamFlowsPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseUpstreamFlowsPart(databaseId));
    };
    SiteUrls.catalogDatabaseUpstreamFlowsPart = function (databaseId) {
        return "" + SiteUrls.catalogDatabasePart(databaseId) + SiteUrls.upstreamPart() + SiteUrls.flowsPart();
    };
    SiteUrls.prototype.catalogDatabaseUpstreamDatasourcesUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseUpstreamDatasourcesPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseUpstreamDatasourcesPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseUpstreamDatasourcesPart(databaseId));
    };
    SiteUrls.catalogDatabaseUpstreamDatasourcesPart = function (databaseId) {
        return "" + SiteUrls.catalogDatabasePart(databaseId) + SiteUrls.upstreamPart() + SiteUrls.datasourcesPart();
    };
    SiteUrls.prototype.catalogDatabaseDownstreamDatabasesUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseDownstreamDatabasesPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseDownstreamDatabasesPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseDownstreamDatabasesPart(databaseId));
    };
    SiteUrls.catalogDatabaseDownstreamDatabasesPart = function (databaseId) {
        return "" + SiteUrls.catalogDatabasePart(databaseId) + SiteUrls.downstreamPart() + SiteUrls.databasesPart();
    };
    SiteUrls.prototype.catalogDatabaseDownstreamTablesUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseDownstreamTablesPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseDownstreamTablesPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseDownstreamTablesPart(databaseId));
    };
    SiteUrls.catalogDatabaseDownstreamTablesPart = function (databaseId) {
        return "" + SiteUrls.catalogDatabasePart(databaseId) + SiteUrls.downstreamPart() + SiteUrls.tablesPart();
    };
    SiteUrls.prototype.catalogDatabaseDownstreamFlowsUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseDownstreamFlowsPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseDownstreamFlowsPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseDownstreamFlowsPart(databaseId));
    };
    SiteUrls.catalogDatabaseDownstreamFlowsPart = function (databaseId) {
        return "" + SiteUrls.catalogDatabasePart(databaseId) + SiteUrls.downstreamPart() + SiteUrls.flowsPart();
    };
    SiteUrls.prototype.catalogDatabaseDownstreamDatasourcesUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseDownstreamDatasourcesPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseDownstreamDatasourcesPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseDownstreamDatasourcesPart(databaseId));
    };
    SiteUrls.catalogDatabaseDownstreamDatasourcesPart = function (databaseId) {
        return "" + SiteUrls.catalogDatabasePart(databaseId) + SiteUrls.downstreamPart() + SiteUrls.datasourcesPart();
    };
    SiteUrls.prototype.catalogDatabaseDownstreamWorkbooksUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseDownstreamWorkbooksPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseDownstreamWorkbooksPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseDownstreamWorkbooksPart(databaseId));
    };
    SiteUrls.catalogDatabaseDownstreamWorkbooksPart = function (databaseId) {
        return "" + SiteUrls.catalogDatabasePart(databaseId) + SiteUrls.downstreamPart() + SiteUrls.workbooksPart();
    };
    SiteUrls.prototype.catalogDatabaseDownstreamDashboardsUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseDownstreamDashboardsPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseDownstreamDashboardsPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseDownstreamDashboardsPart(databaseId));
    };
    SiteUrls.catalogDatabaseDownstreamDashboardsPart = function (databaseId) {
        return "" + SiteUrls.catalogDatabasePart(databaseId) + SiteUrls.downstreamPart() + SiteUrls.dashboardsPart();
    };
    SiteUrls.prototype.catalogDatabaseDownstreamSheetsUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseDownstreamSheetsPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseDownstreamSheetsPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseDownstreamSheetsPart(databaseId));
    };
    SiteUrls.catalogDatabaseDownstreamSheetsPart = function (databaseId) {
        return "" + SiteUrls.catalogDatabasePart(databaseId) + SiteUrls.downstreamPart() + SiteUrls.sheetsPart();
    };
    SiteUrls.prototype.catalogDatabaseDownstreaMetricsUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseDownstreamMetricsPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseDownstreamMetricsPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseDownstreamMetricsPart(databaseId));
    };
    SiteUrls.catalogDatabaseDownstreamMetricsPart = function (databaseId) {
        return "" + SiteUrls.catalogDatabasePart(databaseId) + SiteUrls.downstreamPart() + SiteUrls.lineageMetricsPart();
    };
    SiteUrls.prototype.catalogDatabaseDownstreamOwnersUrl = function (databaseId) {
        return this.fullUrl(this.catalogDatabaseDownstreamOwnersPath(databaseId));
    };
    SiteUrls.prototype.catalogDatabaseDownstreamOwnersPath = function (databaseId) {
        return this.sitePath(SiteUrls.catalogDatabaseDownstreamOwnersPart(databaseId));
    };
    SiteUrls.catalogDatabaseDownstreamOwnersPart = function (databaseId) {
        return "" + SiteUrls.catalogDatabasePart(databaseId) + SiteUrls.downstreamPart() + SiteUrls.ownersPart();
    };
    SiteUrls.prototype.catalogDatabasesWithTagUrl = function (tag) {
        return this.fullUrl(this.catalogDatabasesWithTagPath(tag));
    };
    SiteUrls.prototype.catalogDatabasesWithTagPath = function (tag) {
        return this.sitePath(SiteUrls.catalogDatabasesWithTagPart(tag));
    };
    SiteUrls.catalogDatabasesWithTagPart = function (tag) {
        return "" + SiteUrls.catalogDatabasesPart() + SiteUrls.tagPart(tag);
    };
    SiteUrls.prototype.catalogTablesWithTagUrl = function (tag) {
        return this.fullUrl(this.catalogTablesWithTagPath(tag));
    };
    SiteUrls.prototype.catalogTablesWithTagPath = function (tag) {
        return this.sitePath(SiteUrls.catalogTablesWithTagPart(tag));
    };
    SiteUrls.catalogTablesWithTagPart = function (tag) {
        return "" + SiteUrls.catalogTablesPart() + SiteUrls.tagPart(tag);
    };
    // Explore
    SiteUrls.prototype.exploreUrl = function () {
        return this.fullUrl(this.explorePath());
    };
    SiteUrls.prototype.explorePath = function () {
        return this.sitePath(SiteUrls.explorePart());
    };
    SiteUrls.explorePart = function () {
        return '/explore';
    };
    // DataRole
    SiteUrls.prototype.dataRolesUrl = function () {
        return this.fullUrl(this.dataRolesPath());
    };
    SiteUrls.prototype.dataRolesPath = function () {
        return this.sitePath(SiteUrls.dataRolesPart());
    };
    SiteUrls.dataRolesPart = function () {
        return '/dataRoles';
    };
    SiteUrls.prototype.dataRoleUrl = function (roleId) {
        return this.fullUrl(this.dataRolePath(roleId));
    };
    SiteUrls.prototype.dataRolePath = function (roleId) {
        return this.sitePath(SiteUrls.dataRolePart(roleId));
    };
    SiteUrls.dataRolePart = function (roleId) {
        return SiteUrls.dataRolesPart() + "/" + roleId;
    };
    SiteUrls.prototype.redirectToDataRoleUrl = function (roleId) {
        return this.fullUrl(this.redirectToDataRolePath(roleId));
    };
    SiteUrls.prototype.redirectToDataRolePath = function (roleId) {
        return this.sitePath(SiteUrls.redirectToDataRolePart(roleId));
    };
    SiteUrls.redirectToDataRolePart = function (roleId) {
        return "/redirect_to_data_role/" + roleId;
    };
    SiteUrls.prototype.dataRoleConnectedFlowsUrl = function (roleId) {
        return this.fullUrl(this.dataRoleConnectedFlowsPath(roleId));
    };
    SiteUrls.prototype.dataRoleConnectedFlowsPath = function (roleId) {
        return this.sitePath(SiteUrls.dataRoleConnectedFlowsPart(roleId));
    };
    SiteUrls.dataRoleConnectedFlowsPart = function (roleId) {
        return SiteUrls.dataRolesPart() + "/" + roleId + this.connectedFlowsPart();
    };
    SiteUrls.connectedFlowsPart = function () {
        return '/connectedFlows';
    };
    SiteUrls.prototype.dataRoleConnectedDatasourcesUrl = function (roleId) {
        return this.fullUrl(this.dataRoleConnectedDatasourcesPath(roleId));
    };
    SiteUrls.prototype.dataRoleConnectedDatasourcesPath = function (roleId) {
        return this.sitePath(SiteUrls.dataRoleConnectedDatasourcesPart(roleId));
    };
    SiteUrls.dataRoleConnectedDatasourcesPart = function (roleId) {
        return SiteUrls.dataRolesPart() + "/" + roleId + this.connectedDatasourcesPart();
    };
    SiteUrls.connectedDatasourcesPart = function () {
        return '/connectedDatasources';
    };
    SiteUrls.prototype.dataRoleDefinitionUrl = function (roleId) {
        return this.fullUrl(this.dataRoleDefinitionPath(roleId));
    };
    SiteUrls.prototype.dataRoleDefinitionPath = function (roleId) {
        return this.sitePath(SiteUrls.dataRoleDefinitionPart(roleId));
    };
    SiteUrls.dataRoleDefinitionPart = function (roleId) {
        return SiteUrls.dataRolesPart() + "/" + roleId + this.definitionPart();
    };
    SiteUrls.definitionPart = function () {
        return '/definition';
    };
    // Lenses
    SiteUrls.prototype.lensesUrl = function () {
        return this.fullUrl(this.lensesPath());
    };
    SiteUrls.prototype.lensesPath = function () {
        return this.sitePath(SiteUrls.lensesPart());
    };
    SiteUrls.lensesPart = function () {
        return '/lenses';
    };
    SiteUrls.prototype.lensUrl = function (lensId) {
        return this.fullUrl(this.lensPath(lensId));
    };
    SiteUrls.prototype.lensPath = function (lensId) {
        return this.sitePath(SiteUrls.lensPart(lensId));
    };
    SiteUrls.lensPart = function (lensId) {
        return SiteUrls.lensesPart() + "/" + lensId;
    };
    SiteUrls.prototype.lensUsageAnalyticsUrl = function (lensId) {
        return this.fullUrl(this.lensUsageAnalyticsPath(lensId));
    };
    SiteUrls.prototype.lensUsageAnalyticsPath = function (lensId) {
        return this.sitePath(SiteUrls.lensUsageAnalyticsPart(lensId));
    };
    SiteUrls.lensUsageAnalyticsPart = function (lensId) {
        return "" + SiteUrls.lensPart(lensId) + SiteUrls.usageAnalyticsPart();
    };
    SiteUrls.usageAnalyticsPart = function () {
        return '/usageAnalytics';
    };
    // Flows
    SiteUrls.prototype.flowsUrl = function () {
        return this.fullUrl(this.flowsPath());
    };
    SiteUrls.prototype.flowsPath = function () {
        return this.sitePath(SiteUrls.flowsPart());
    };
    SiteUrls.flowsPart = function () {
        return '/flows';
    };
    SiteUrls.prototype.flowUrl = function (flowId) {
        return this.fullUrl(this.flowPath(flowId));
    };
    SiteUrls.prototype.flowPath = function (flowId) {
        return this.sitePath(SiteUrls.flowPart(flowId));
    };
    SiteUrls.flowPart = function (flowId) {
        return SiteUrls.flowsPart() + "/" + flowId;
    };
    // TODO: remove in favor of redirectToFlowUrl?
    SiteUrls.prototype.favoriteFlowUrl = function (flowId) {
        return this.redirectToFlowUrl(flowId);
    };
    SiteUrls.prototype.redirectToFlowUrl = function (flowId) {
        return this.fullUrl(this.redirectToFlowPath(flowId));
    };
    SiteUrls.prototype.redirectToFlowPath = function (flowId) {
        return this.sitePath(SiteUrls.redirectToFlowPart(flowId));
    };
    SiteUrls.redirectToFlowPart = function (flowId) {
        return "/redirect_to_flow/" + flowId;
    };
    SiteUrls.prototype.flowsWithTagUrl = function (tag) {
        return this.fullUrl(this.flowsWithTagPath(tag));
    };
    SiteUrls.prototype.flowsWithTagPath = function (tag) {
        return this.sitePath(SiteUrls.flowsWithTagPart(tag));
    };
    SiteUrls.flowsWithTagPart = function (tag) {
        return "" + SiteUrls.flowsPart() + SiteUrls.tagPart(tag);
    };
    SiteUrls.tagPart = function (tag) {
        return "?" + tagParam(tag);
    };
    SiteUrls.prototype.flowConnectionsUrl = function (flowId) {
        return this.fullUrl(this.flowConnectionsPath(flowId));
    };
    SiteUrls.prototype.flowConnectionsPath = function (flowId) {
        return this.sitePath(SiteUrls.flowConnectionsPart(flowId));
    };
    SiteUrls.flowConnectionsPart = function (flowId) {
        return "" + SiteUrls.flowPart(flowId) + SiteUrls.connectionsPart();
    };
    // Used for search url as well
    SiteUrls.connectionsPart = function () {
        return '/connections';
    };
    SiteUrls.prototype.flowOverviewUrl = function (flowId) {
        return this.fullUrl(this.flowOverviewPath(flowId));
    };
    SiteUrls.prototype.flowOverviewPath = function (flowId) {
        return this.sitePath(SiteUrls.flowOverviewPart(flowId));
    };
    SiteUrls.flowOverviewPart = function (flowId) {
        return "" + SiteUrls.flowPart(flowId) + SiteUrls.overviewPart();
    };
    SiteUrls.overviewPart = function () {
        return '/overview';
    };
    SiteUrls.prototype.flowRunHistoryUrl = function (flowId) {
        return this.fullUrl(this.flowRunHistoryPath(flowId));
    };
    SiteUrls.prototype.flowRunHistoryPath = function (flowId) {
        return this.sitePath(SiteUrls.flowRunHistoryPart(flowId));
    };
    SiteUrls.flowRunHistoryPart = function (flowId) {
        return "" + SiteUrls.flowPart(flowId) + SiteUrls.runHistoryPart();
    };
    SiteUrls.runHistoryPart = function () {
        return '/runHistory';
    };
    SiteUrls.prototype.flowScheduledTasksUrl = function (flowId) {
        return this.fullUrl(this.flowScheduledTasksPath(flowId));
    };
    SiteUrls.prototype.flowScheduledTasksPath = function (flowId) {
        return this.sitePath(SiteUrls.flowScheduledTasksPart(flowId));
    };
    SiteUrls.flowScheduledTasksPart = function (flowId) {
        return "" + SiteUrls.flowPart(flowId) + SiteUrls.scheduledTasksPart();
    };
    SiteUrls.scheduledTasksPart = function () {
        return '/scheduledTasks';
    };
    SiteUrls.prototype.flowLineageUrl = function (flowId) {
        return this.fullUrl(this.flowLineagePath(flowId));
    };
    SiteUrls.prototype.flowLineagePath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineagePart(flowId));
    };
    SiteUrls.flowLineagePart = function (flowId) {
        return "" + SiteUrls.flowPart(flowId) + SiteUrls.lineagePart();
    };
    SiteUrls.prototype.flowLineageFieldsUrl = function (flowId) {
        return this.fullUrl(this.flowLineageFieldsPath(flowId));
    };
    SiteUrls.prototype.flowLineageFieldsPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageFieldsPart(flowId));
    };
    SiteUrls.flowLineageFieldsPart = function (flowId) {
        return "" + SiteUrls.flowLineagePart(flowId) + SiteUrls.fieldsPart();
    };
    SiteUrls.prototype.flowLineageFieldUrl = function (flowId, fieldId) {
        return this.fullUrl(this.flowLineageFieldPath(flowId, fieldId));
    };
    SiteUrls.prototype.flowLineageFieldPath = function (flowId, fieldId) {
        return this.sitePath(SiteUrls.flowLineageFieldPart(flowId, fieldId));
    };
    SiteUrls.flowLineageFieldPart = function (flowId, fieldId) {
        return "" + SiteUrls.flowLineagePart(flowId) + SiteUrls.fieldsPart() + "/" + fieldId;
    };
    SiteUrls.prototype.flowLineageUpstreamDatabasesUrl = function (flowId) {
        return this.fullUrl(this.flowLineageUpstreamDatabasesPath(flowId));
    };
    SiteUrls.prototype.flowLineageUpstreamDatabasesPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageUpstreamDatabasesPart(flowId));
    };
    SiteUrls.flowLineageUpstreamDatabasesPart = function (flowId) {
        return "" + SiteUrls.flowLineagePart(flowId) + SiteUrls.upstreamPart() + SiteUrls.databasesPart();
    };
    SiteUrls.prototype.flowLineageUpstreamTablesUrl = function (flowId) {
        return this.fullUrl(this.flowLineageUpstreamTablesPath(flowId));
    };
    SiteUrls.prototype.flowLineageUpstreamTablesPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageUpstreamTablesPart(flowId));
    };
    SiteUrls.flowLineageUpstreamTablesPart = function (flowId) {
        return "" + SiteUrls.flowLineagePart(flowId) + SiteUrls.upstreamPart() + SiteUrls.tablesPart();
    };
    SiteUrls.prototype.flowLineageUpstreamFlowsUrl = function (flowId) {
        return this.fullUrl(this.flowLineageUpstreamFlowsPath(flowId));
    };
    SiteUrls.prototype.flowLineageUpstreamFlowsPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageUpstreamFlowsPart(flowId));
    };
    SiteUrls.flowLineageUpstreamFlowsPart = function (flowId) {
        return "" + SiteUrls.flowLineagePart(flowId) + SiteUrls.upstreamPart() + SiteUrls.flowsPart();
    };
    SiteUrls.prototype.flowLineageUpstreamDatasourcesUrl = function (flowId) {
        return this.fullUrl(this.flowLineageUpstreamDatasourcesPath(flowId));
    };
    SiteUrls.prototype.flowLineageUpstreamDatasourcesPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageUpstreamDatasourcesPart(flowId));
    };
    SiteUrls.flowLineageUpstreamDatasourcesPart = function (flowId) {
        return "" + SiteUrls.flowLineagePart(flowId) + SiteUrls.upstreamPart() + SiteUrls.datasourcesPart();
    };
    SiteUrls.prototype.flowLineageDownstreamDatabasesUrl = function (flowId) {
        return this.fullUrl(this.flowLineageDownstreamDatabasesPath(flowId));
    };
    SiteUrls.prototype.flowLineageDownstreamDatabasesPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageDownstreamDatabasesPart(flowId));
    };
    SiteUrls.flowLineageDownstreamDatabasesPart = function (flowId) {
        return "" + SiteUrls.flowLineagePart(flowId) + SiteUrls.downstreamPart() + SiteUrls.databasesPart();
    };
    SiteUrls.prototype.flowLineageDownstreamTablesUrl = function (flowId) {
        return this.fullUrl(this.flowLineageDownstreamTablesPath(flowId));
    };
    SiteUrls.prototype.flowLineageDownstreamTablesPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageDownstreamTablesPart(flowId));
    };
    SiteUrls.flowLineageDownstreamTablesPart = function (flowId) {
        return "" + SiteUrls.flowLineagePart(flowId) + SiteUrls.downstreamPart() + SiteUrls.tablesPart();
    };
    SiteUrls.prototype.flowLineageDownstreamFlowsUrl = function (flowId) {
        return this.fullUrl(this.flowLineageDownstreamFlowsPath(flowId));
    };
    SiteUrls.prototype.flowLineageDownstreamFlowsPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageDownstreamFlowsPart(flowId));
    };
    SiteUrls.flowLineageDownstreamFlowsPart = function (flowId) {
        return "" + SiteUrls.flowLineagePart(flowId) + SiteUrls.downstreamPart() + SiteUrls.flowsPart();
    };
    SiteUrls.prototype.flowLineageDownstreamDatasourcesUrl = function (flowId) {
        return this.fullUrl(this.flowLineageDownstreamDatasourcesPath(flowId));
    };
    SiteUrls.prototype.flowLineageDownstreamDatasourcesPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageDownstreamDatasourcesPart(flowId));
    };
    SiteUrls.flowLineageDownstreamDatasourcesPart = function (flowId) {
        return "" + SiteUrls.flowLineagePart(flowId) + SiteUrls.downstreamPart() + SiteUrls.datasourcesPart();
    };
    SiteUrls.prototype.flowLineageDownstreamWorkbooksUrl = function (flowId) {
        return this.fullUrl(this.flowLineageDownstreamWorkbooksPath(flowId));
    };
    SiteUrls.prototype.flowLineageDownstreamWorkbooksPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageDownstreamWorkbooksPart(flowId));
    };
    SiteUrls.flowLineageDownstreamWorkbooksPart = function (flowId) {
        return "" + SiteUrls.flowLineagePart(flowId) + SiteUrls.downstreamPart() + SiteUrls.workbooksPart();
    };
    SiteUrls.prototype.flowLineageDownstreamDashboardsUrl = function (flowId) {
        return this.fullUrl(this.flowLineageDownstreamDashboardsPath(flowId));
    };
    SiteUrls.prototype.flowLineageDownstreamDashboardsPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageDownstreamDashboardsPart(flowId));
    };
    SiteUrls.flowLineageDownstreamDashboardsPart = function (flowId) {
        return "" + SiteUrls.flowLineagePart(flowId) + SiteUrls.downstreamPart() + SiteUrls.dashboardsPart();
    };
    SiteUrls.prototype.flowLineageDownstreamSheetsUrl = function (flowId) {
        return this.fullUrl(this.flowLineageDownstreamSheetsPath(flowId));
    };
    SiteUrls.prototype.flowLineageDownstreamSheetsPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageDownstreamSheetsPart(flowId));
    };
    SiteUrls.flowLineageDownstreamSheetsPart = function (flowId) {
        return "" + SiteUrls.flowLineagePart(flowId) + SiteUrls.downstreamPart() + SiteUrls.sheetsPart();
    };
    SiteUrls.prototype.flowLineageDownstreaMetricsUrl = function (flowId) {
        return this.fullUrl(this.flowLineageDownstreamMetricsPath(flowId));
    };
    SiteUrls.prototype.flowLineageDownstreamMetricsPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageDownstreamMetricsPart(flowId));
    };
    SiteUrls.flowLineageDownstreamMetricsPart = function (flowId) {
        return "" + SiteUrls.flowLineagePart(flowId) + SiteUrls.downstreamPart() + SiteUrls.lineageMetricsPart();
    };
    SiteUrls.prototype.flowLineageDownstreamOwnersUrl = function (flowId) {
        return this.fullUrl(this.flowLineageDownstreamOwnersPath(flowId));
    };
    SiteUrls.prototype.flowLineageDownstreamOwnersPath = function (flowId) {
        return this.sitePath(SiteUrls.flowLineageDownstreamOwnersPart(flowId));
    };
    SiteUrls.flowLineageDownstreamOwnersPart = function (flowId) {
        return "" + SiteUrls.flowLineagePart(flowId) + SiteUrls.downstreamPart() + SiteUrls.ownersPart();
    };
    SiteUrls.prototype.flowPublishresultUrl = function (flowId) {
        return this.fullUrl(this.flowPublishresultPath(flowId));
    };
    SiteUrls.prototype.flowPublishresultPath = function (flowId) {
        return this.sitePath(SiteUrls.flowPublishresultPart(flowId));
    };
    SiteUrls.flowPublishresultPart = function (flowId) {
        return "" + SiteUrls.flowPart(flowId) + SiteUrls.publishresultPart();
    };
    // Projects
    SiteUrls.prototype.projectsUrl = function () {
        return this.fullUrl(this.projectsPath());
    };
    SiteUrls.prototype.projectsPath = function () {
        return this.sitePath(SiteUrls.projectsPart());
    };
    SiteUrls.projectsPart = function () {
        return '/projects';
    };
    SiteUrls.prototype.projectUrl = function (projectId) {
        return this.fullUrl(this.projectPath(projectId));
    };
    SiteUrls.prototype.projectPath = function (projectId) {
        return this.sitePath(SiteUrls.projectPart(projectId));
    };
    SiteUrls.projectPart = function (projectId) {
        return SiteUrls.projectsPart() + "/" + projectId;
    };
    SiteUrls.prototype.projectViewsUrl = function (projectId) {
        return this.fullUrl(this.projectViewsPath(projectId));
    };
    SiteUrls.prototype.projectViewsPath = function (projectId) {
        return this.sitePath(SiteUrls.projectViewsPart(projectId));
    };
    SiteUrls.projectViewsPart = function (projectId) {
        return "" + SiteUrls.projectPart(projectId) + SiteUrls.viewsPart();
    };
    // TODO: remove in favor of redirectToProjectUrl?
    SiteUrls.prototype.favoriteProjectUrl = function (projectId) {
        return this.redirectToProjectUrl(projectId);
    };
    SiteUrls.prototype.redirectToProjectUrl = function (projectId) {
        return this.fullUrl(this.redirectToProjectPath(projectId));
    };
    SiteUrls.prototype.redirectToProjectPath = function (projectId) {
        return this.sitePath(SiteUrls.redirectToProjectPart(projectId));
    };
    SiteUrls.redirectToProjectPart = function (projectId) {
        return "/redirect_to_project/" + projectId;
    };
    // FlowEditor
    SiteUrls.prototype.flowEditorPath = function () {
        return this.sitePath(SiteUrls.flowEditorPart());
    };
    SiteUrls.prototype.flowEditorDraftUrl = function (draftLuid) {
        return this.flowEditorDraftPath(draftLuid);
    };
    SiteUrls.prototype.flowEditorDraftPath = function (draftLuid) {
        return "" + this.flowEditorPath() + SiteUrls.flowEditorDraftPart(draftLuid);
    };
    SiteUrls.prototype.flowEditorFlowPath = function (params) {
        var flowLuid = params.flowLuid, datasourceUrlName = params.datasourceUrlName, projectId = params.projectId;
        return "" + this.flowEditorPath() + SiteUrls.flowEditorFlowsPart() + "/" + flowLuid + SiteUrls.flowEditorFlowParamPart({
            datasourceUrlName: datasourceUrlName,
            projectId: projectId
        });
    };
    SiteUrls.flowEditorPart = function () {
        return '/flow-editor';
    };
    SiteUrls.flowEditorDraftPart = function (draftLuid) {
        return "/drafts/" + draftLuid;
    };
    SiteUrls.flowEditorFlowsPart = function () {
        return '/flows';
    };
    SiteUrls.flowEditorFlowParamPart = function (params) {
        var urlSearchParams = new URLSearchParams();
        if (params.datasourceUrlName) {
            urlSearchParams.set('datasource', params.datasourceUrlName);
        }
        if (params.projectId) {
            urlSearchParams.set('projectId', params.projectId);
        }
        var paramPart = urlSearchParams.toString();
        return paramPart === '' ? paramPart : "?" + paramPart;
    };
    // PublishedConnections
    SiteUrls.prototype.publishedConnectionsUrl = function () {
        return this.fullUrl(this.publishedConnectionsPath());
    };
    SiteUrls.prototype.publishedConnectionsPath = function () {
        return this.sitePath(SiteUrls.publishedConnectionsPart());
    };
    SiteUrls.publishedConnectionsPart = function () {
        return '/publishedConnections';
    };
    SiteUrls.prototype.publishedConnectionsWithTagUrl = function (tag) {
        return this.fullUrl(this.publishedConnectionsWithTagPath(tag));
    };
    SiteUrls.prototype.publishedConnectionsWithTagPath = function (tag) {
        return this.sitePath(SiteUrls.publishedConnectionsWithTagPart(tag));
    };
    SiteUrls.publishedConnectionsWithTagPart = function (tag) {
        return "" + SiteUrls.publishedConnectionsPart() + SiteUrls.tagPart(tag);
    };
    SiteUrls.prototype.favoritePublishedConnectionUrl = function (metricId) {
        return this.redirectToPublishedConnectionUrl(metricId);
    };
    SiteUrls.prototype.publishedConnectionUrl = function (id) {
        return this.fullUrl(this.publishedConnectionPath(id));
    };
    SiteUrls.prototype.publishedConnectionPath = function (id) {
        return this.sitePath(SiteUrls.publishedConnectionPart(id));
    };
    SiteUrls.publishedConnectionPart = function (id) {
        return SiteUrls.publishedConnectionsPart() + "/" + id;
    };
    SiteUrls.prototype.redirectToPublishedConnectionUrl = function (id) {
        return this.fullUrl(this.redirectToPublishedConnectionPath(id));
    };
    SiteUrls.prototype.redirectToPublishedConnectionPath = function (id) {
        return this.sitePath(SiteUrls.redirectToPublishedConnectionPart(id));
    };
    SiteUrls.redirectToPublishedConnectionPart = function (id) {
        return "/redirect_to_published_connection/" + id;
    };
    SiteUrls.prototype.publishedConnectionOverviewUrl = function (publishedConnectionId) {
        return this.fullUrl(this.publishedConnectionOverviewPath(publishedConnectionId));
    };
    SiteUrls.prototype.publishedConnectionOverviewPath = function (publishedConnectionId) {
        return this.sitePath(SiteUrls.publishedConnectionOverviewPart(publishedConnectionId));
    };
    SiteUrls.publishedConnectionOverviewPart = function (publishedConnectionId) {
        return "" + SiteUrls.publishedConnectionPart(publishedConnectionId) + SiteUrls.overviewPart();
    };
    SiteUrls.prototype.publishedConnectionScheduledTasksUrl = function (flowId) {
        return this.fullUrl(this.publishedConnectionScheduledTasksPath(flowId));
    };
    SiteUrls.prototype.publishedConnectionScheduledTasksPath = function (flowId) {
        return this.sitePath(SiteUrls.publishedConnectionScheduledTasksPart(flowId));
    };
    SiteUrls.publishedConnectionScheduledTasksPart = function (flowId) {
        return "" + SiteUrls.publishedConnectionPart(flowId) + SiteUrls.scheduledTasksPart();
    };
    // Workbooks
    SiteUrls.prototype.workbooksUrl = function () {
        return this.fullUrl(this.workbooksPath());
    };
    SiteUrls.prototype.workbooksPath = function () {
        return this.sitePath(SiteUrls.workbooksPart());
    };
    SiteUrls.workbooksPart = function () {
        return '/workbooks';
    };
    SiteUrls.prototype.workbooksWithTagUrl = function (tag) {
        return this.fullUrl(this.workbooksWithTagPath(tag));
    };
    SiteUrls.prototype.workbooksWithTagPath = function (tag) {
        return this.sitePath(SiteUrls.workbooksWithTagPart(tag));
    };
    SiteUrls.workbooksWithTagPart = function (tag) {
        return "" + SiteUrls.workbooksPart() + SiteUrls.tagPart(tag);
    };
    SiteUrls.prototype.workbookUrl = function (workbookId) {
        return this.fullUrl(this.workbookPath(workbookId));
    };
    SiteUrls.prototype.workbookPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookPart(workbookId));
    };
    SiteUrls.workbookPart = function (workbookId) {
        return SiteUrls.workbooksPart() + "/" + workbookId;
    };
    SiteUrls.prototype.workbookViewsUrl = function (workbookId) {
        return this.fullUrl(this.workbookViewsPath(workbookId));
    };
    SiteUrls.prototype.workbookViewsPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookViewsPart(workbookId));
    };
    SiteUrls.workbookViewsPart = function (workbookId) {
        return "" + SiteUrls.workbookPart(workbookId) + SiteUrls.viewsPart();
    };
    SiteUrls.prototype.workbookCustomViewsUrl = function (workbookId) {
        return this.fullUrl(this.workbookCustomViewsPath(workbookId));
    };
    SiteUrls.prototype.workbookCustomViewsPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookCustomViewsPart(workbookId));
    };
    SiteUrls.workbookCustomViewsPart = function (workbookId) {
        return "" + SiteUrls.workbookPart(workbookId) + SiteUrls.customViewsPart();
    };
    SiteUrls.customViewsPart = function () {
        return '/customViews';
    };
    SiteUrls.prototype.workbookSubscriptionsUrl = function (workbookId) {
        return this.fullUrl(this.workbookSubscriptionsPath(workbookId));
    };
    SiteUrls.prototype.workbookSubscriptionsPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookSubscriptionsPart(workbookId));
    };
    SiteUrls.workbookSubscriptionsPart = function (workbookId) {
        return "" + SiteUrls.workbookPart(workbookId) + SiteUrls.subscriptionsPart();
    };
    SiteUrls.prototype.workbookExtractRefreshesUrl = function (workbookId) {
        return this.fullUrl(this.workbookExtractRefreshesPath(workbookId));
    };
    SiteUrls.prototype.workbookExtractRefreshesPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookExtractRefreshesPart(workbookId));
    };
    SiteUrls.workbookExtractRefreshesPart = function (workbookId) {
        return "" + SiteUrls.workbookPart(workbookId) + SiteUrls.extractRefreshesPart();
    };
    SiteUrls.prototype.workbookDetailsUrl = function (workbookId) {
        return this.fullUrl(this.workbookDetailsPath(workbookId));
    };
    SiteUrls.prototype.workbookDetailsPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookDetailsPart(workbookId));
    };
    SiteUrls.workbookDetailsPart = function (workbookId) {
        return "" + SiteUrls.workbookPart(workbookId) + SiteUrls.detailsPart();
    };
    SiteUrls.prototype.workbookPublishresultUrl = function (workbookId) {
        return this.fullUrl(this.workbookPublishresultPath(workbookId));
    };
    SiteUrls.prototype.workbookPublishresultPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookPublishresultPart(workbookId));
    };
    SiteUrls.workbookPublishresultPart = function (workbookId) {
        return "" + SiteUrls.workbookPart(workbookId) + SiteUrls.publishresultPart();
    };
    SiteUrls.publishresultPart = function () {
        return '/publishresult';
    };
    SiteUrls.prototype.workbookDatasourcesUrl = function (workbookId) {
        return this.fullUrl(this.workbookDatasourcesPath(workbookId));
    };
    SiteUrls.prototype.workbookDatasourcesPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookDatasourcesPart(workbookId));
    };
    SiteUrls.workbookDatasourcesPart = function (workbookId) {
        return "" + SiteUrls.workbookPart(workbookId) + SiteUrls.datasourcesPart();
    };
    SiteUrls.prototype.workbookConnectedMetricsUrl = function (workbookId) {
        return this.fullUrl(this.workbookConnectedMetricsPath(workbookId));
    };
    SiteUrls.prototype.workbookConnectedMetricsPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookConnectedMetricsPart(workbookId));
    };
    SiteUrls.workbookConnectedMetricsPart = function (workbookId) {
        return "" + SiteUrls.workbookPart(workbookId) + SiteUrls.connectedMetricsPart();
    };
    SiteUrls.connectedMetricsPart = function () {
        return '/connectedMetrics';
    };
    // TODO: remove in favor of redirectToWorkbookUrl?
    SiteUrls.prototype.favoriteWorkbookUrl = function (workbookId) {
        return this.redirectToWorkbookUrl(workbookId);
    };
    SiteUrls.prototype.redirectToWorkbookUrl = function (workbookId) {
        return this.fullUrl(this.redirectToWorkbookPath(workbookId));
    };
    SiteUrls.prototype.redirectToWorkbookPath = function (workbookId) {
        return this.sitePath(SiteUrls.redirectToWorkbookPart(workbookId));
    };
    SiteUrls.redirectToWorkbookPart = function (workbookId) {
        return "/redirect_to_workbook/" + workbookId;
    };
    SiteUrls.prototype.workbookRevisionPreviewUrl = function (revisionPath) {
        return this.fullUrl(this.workbookRevisionPreviewPath(revisionPath));
    };
    SiteUrls.prototype.workbookRevisionPreviewPath = function (revisionPath) {
        return this.sitePath(SiteUrls.workbookRevisionPreviewPart(revisionPath));
    };
    SiteUrls.workbookRevisionPreviewPart = function (revisionPath) {
        return "/" + revisionPath;
    };
    SiteUrls.prototype.workbookLineageUrl = function (workbookId) {
        return this.fullUrl(this.workbookLineagePath(workbookId));
    };
    SiteUrls.prototype.workbookLineagePath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookLineagePart(workbookId));
    };
    SiteUrls.workbookLineagePart = function (workbookId) {
        return "" + SiteUrls.workbookPart(workbookId) + SiteUrls.lineagePart();
    };
    SiteUrls.prototype.workbookLineageFieldsUrl = function (workbookId, embeddedDatasourceId) {
        return this.fullUrl(this.workbookLineageFieldsPath(workbookId, embeddedDatasourceId));
    };
    SiteUrls.prototype.workbookLineageFieldsPath = function (workbookId, embeddedDatasourceId) {
        return this.sitePath(SiteUrls.workbookLineageFieldsPart(workbookId, embeddedDatasourceId));
    };
    SiteUrls.workbookLineageFieldsPart = function (workbookId, embeddedDatasourceId) {
        var workbookLineagePart = SiteUrls.workbookLineagePart(workbookId);
        var fieldsPart = SiteUrls.fieldsPart();
        var embeddedDatasourceParamPart = this.workbookLineageEmbeddedDatasourceParamPart(embeddedDatasourceId);
        return "" + workbookLineagePart + fieldsPart + embeddedDatasourceParamPart;
    };
    SiteUrls.workbookLineageEmbeddedDatasourceParamPart = function (embeddedDatasourceId) {
        return embeddedDatasourceId === undefined ? '' : "?" + CatalogUrlParamKeys.embeddedDataSource + "=" + embeddedDatasourceId;
    };
    SiteUrls.prototype.workbookLineageFieldUrl = function (workbookId, fieldId) {
        return this.fullUrl(this.workbookLineageFieldPath(workbookId, fieldId));
    };
    SiteUrls.prototype.workbookLineageFieldPath = function (workbookId, fieldId) {
        return this.sitePath(SiteUrls.workbookLineageFieldPart(workbookId, fieldId));
    };
    SiteUrls.workbookLineageFieldPart = function (workbookId, fieldId) {
        return "" + SiteUrls.workbookLineagePart(workbookId) + SiteUrls.fieldsPart() + "/" + fieldId;
    };
    SiteUrls.prototype.workbookLineageUpstreamDatabasesUrl = function (workbookId) {
        return this.fullUrl(this.workbookLineageUpstreamDatabasesPath(workbookId));
    };
    SiteUrls.prototype.workbookLineageUpstreamDatabasesPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookLineageUpstreamDatabasesPart(workbookId));
    };
    SiteUrls.workbookLineageUpstreamDatabasesPart = function (workbookId) {
        return "" + SiteUrls.workbookLineagePart(workbookId) + SiteUrls.upstreamPart() + SiteUrls.databasesPart();
    };
    SiteUrls.prototype.workbookLineageUpstreamTablesUrl = function (workbookId) {
        return this.fullUrl(this.workbookLineageUpstreamTablesPath(workbookId));
    };
    SiteUrls.prototype.workbookLineageUpstreamTablesPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookLineageUpstreamTablesPart(workbookId));
    };
    SiteUrls.workbookLineageUpstreamTablesPart = function (workbookId) {
        return "" + SiteUrls.workbookLineagePart(workbookId) + SiteUrls.upstreamPart() + SiteUrls.tablesPart();
    };
    SiteUrls.prototype.workbookLineageUpstreamFlowsUrl = function (workbookId) {
        return this.fullUrl(this.workbookLineageUpstreamFlowsPath(workbookId));
    };
    SiteUrls.prototype.workbookLineageUpstreamFlowsPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookLineageUpstreamFlowsPart(workbookId));
    };
    SiteUrls.workbookLineageUpstreamFlowsPart = function (workbookId) {
        return "" + SiteUrls.workbookLineagePart(workbookId) + SiteUrls.upstreamPart() + SiteUrls.flowsPart();
    };
    SiteUrls.prototype.workbookLineageUpstreamDatasourcesUrl = function (workbookId) {
        return this.fullUrl(this.workbookLineageUpstreamDatasourcesPath(workbookId));
    };
    SiteUrls.prototype.workbookLineageUpstreamDatasourcesPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookLineageUpstreamDatasourcesPart(workbookId));
    };
    SiteUrls.workbookLineageUpstreamDatasourcesPart = function (workbookId) {
        return "" + SiteUrls.workbookLineagePart(workbookId) + SiteUrls.upstreamPart() + SiteUrls.datasourcesPart();
    };
    SiteUrls.prototype.workbookLineageDownstreamDashboardsUrl = function (workbookId) {
        return this.fullUrl(this.workbookLineageDownstreamDashboardsPath(workbookId));
    };
    SiteUrls.prototype.workbookLineageDownstreamDashboardsPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookLineageDownstreamDashboardsPart(workbookId));
    };
    SiteUrls.workbookLineageDownstreamDashboardsPart = function (workbookId) {
        return "" + SiteUrls.workbookLineagePart(workbookId) + SiteUrls.downstreamPart() + SiteUrls.dashboardsPart();
    };
    SiteUrls.prototype.workbookLineageDownstreamSheetsUrl = function (workbookId) {
        return this.fullUrl(this.workbookLineageDownstreamSheetsPath(workbookId));
    };
    SiteUrls.prototype.workbookLineageDownstreamSheetsPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookLineageDownstreamSheetsPart(workbookId));
    };
    SiteUrls.workbookLineageDownstreamSheetsPart = function (workbookId) {
        return "" + SiteUrls.workbookLineagePart(workbookId) + SiteUrls.downstreamPart() + SiteUrls.sheetsPart();
    };
    SiteUrls.prototype.workbookLineageDownstreamMetricsUrl = function (workbookId) {
        return this.fullUrl(this.workbookLineageDownstreamMetricsPath(workbookId));
    };
    SiteUrls.prototype.workbookLineageDownstreamMetricsPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookLineageDownstreamMetricsPart(workbookId));
    };
    SiteUrls.workbookLineageDownstreamMetricsPart = function (workbookId) {
        return "" + SiteUrls.workbookLineagePart(workbookId) + SiteUrls.downstreamPart() + SiteUrls.lineageMetricsPart();
    };
    SiteUrls.prototype.workbookLineageDownstreamOwnersUrl = function (tableId) {
        return this.fullUrl(this.workbookLineageDownstreamOwnersPath(tableId));
    };
    SiteUrls.prototype.workbookLineageDownstreamOwnersPath = function (tableId) {
        return this.sitePath(SiteUrls.workbookLineageDownstreamOwnersPart(tableId));
    };
    SiteUrls.workbookLineageDownstreamOwnersPart = function (tableId) {
        return "" + SiteUrls.workbookLineagePart(tableId) + SiteUrls.downstreamPart() + SiteUrls.ownersPart();
    };
    // Views
    SiteUrls.prototype.viewsUrl = function () {
        return this.fullUrl(this.viewsPath());
    };
    SiteUrls.prototype.viewsPath = function () {
        return this.sitePath(SiteUrls.viewsPart());
    };
    SiteUrls.viewsPart = function () {
        return '/views';
    };
    SiteUrls.prototype.viewUrl = function (viewPath) {
        return this.fullUrl(this.viewPath(viewPath));
    };
    SiteUrls.prototype.viewPath = function (viewPath) {
        return this.sitePath(SiteUrls.viewPart(viewPath));
    };
    SiteUrls.viewPart = function (viewPath) {
        return SiteUrls.viewsPart() + "/" + viewPath;
    };
    // TODO: remove this in favor of separate "addParams" helper?
    SiteUrls.prototype.viewWithDeviceTypeUrl = function (viewPath, deviceType) {
        var urlBase = this.viewUrl(viewPath);
        if (deviceType === 'default') {
            return urlBase;
        }
        return urlBase + '?' + deviceTypeParam(deviceType);
    };
    SiteUrls.prototype.redirectToFavoriteViewUrl = function (viewId) {
        return this.fullUrl(this.redirectToFavoriteViewPath(viewId));
    };
    SiteUrls.prototype.redirectToFavoriteViewPath = function (viewId) {
        return this.sitePath(SiteUrls.redirectToFavoriteViewPart(viewId));
    };
    SiteUrls.redirectToFavoriteViewPart = function (viewId) {
        return "/redirect_to_favorite_view/" + viewId;
    };
    SiteUrls.prototype.redirectToViewUrl = function (viewId) {
        return this.fullUrl(this.redirectToViewPath(viewId));
    };
    SiteUrls.prototype.redirectToViewPath = function (viewId) {
        return this.sitePath(SiteUrls.redirectToViewPart(viewId));
    };
    SiteUrls.redirectToViewPart = function (viewId) {
        return "/redirect_to_view/" + viewId;
    };
    // Deprecated, awaiting removal as part of RemoveUsernamesFromCVURL FF removal, tfs1269522
    SiteUrls.prototype.redirectToCustomViewUrl = function (viewId, username, customViewName) {
        return this.fullUrl(this.redirectToCustomViewPath(viewId, username, customViewName));
    };
    // Deprecated, awaiting removal as part of RemoveUsernamesFromCVURL FF removal, tfs1269522
    SiteUrls.prototype.redirectToCustomViewPath = function (viewId, username, customViewName) {
        return this.sitePath(SiteUrls.redirectToCustomViewPart(viewId, username, customViewName));
    };
    // Deprecated, awaiting removal as part of RemoveUsernamesFromCVURL FF removal, tfs1269522
    SiteUrls.redirectToCustomViewPart = function (viewId, username, customViewName) {
        return "/redirect_to_custom_view/" + viewId + "/" + username + "/" + customViewName;
    };
    SiteUrls.prototype.redirectToCustomViewUrlWithLuid = function (viewId, customViewLuid, customViewName) {
        return this.fullUrl(this.redirectToCustomViewPathWithLuid(viewId, customViewLuid, customViewName));
    };
    SiteUrls.prototype.redirectToCustomViewPathWithLuid = function (viewId, customViewLuid, customViewName) {
        return this.sitePath(SiteUrls.redirectToCustomViewPartWithLuid(viewId, customViewLuid, customViewName));
    };
    SiteUrls.redirectToCustomViewPartWithLuid = function (viewId, customViewLuid, customViewName) {
        return "/redirect_to_custom_view/" + viewId + "/" + customViewLuid + "/" + customViewName;
    };
    // Viz recommendations
    // As of Dec 2018, this end-point will be only internally accessable (alpo-dev) and
    // protected by feature flag 'recommendations.viz_recommendations_enabled'
    SiteUrls.prototype.recommendationListUrl = function () {
        return this.fullUrl(this.recommendationListPath());
    };
    SiteUrls.prototype.recommendationListPath = function () {
        return this.sitePath(SiteUrls.recommendationListPart());
    };
    SiteUrls.recommendationListPart = function () {
        return '/recommendations';
    };
    SiteUrls.prototype.recommendationUrl = function (vizId) {
        return this.fullUrl(this.recommendationPath(vizId));
    };
    SiteUrls.prototype.recommendationPath = function (vizId) {
        return this.sitePath(SiteUrls.recommendationPart(vizId));
    };
    SiteUrls.recommendationPart = function (vizId) {
        return SiteUrls.recommendationListPart() + "/" + vizId;
    };
    // Users
    SiteUrls.prototype.usersUrl = function () {
        return this.fullUrl(this.usersPath());
    };
    SiteUrls.prototype.usersPath = function () {
        return this.sitePath(SiteUrls.usersPart());
    };
    SiteUrls.usersPart = function () {
        return '/users';
    };
    // While the user identity migration is in process, we move the users space into the users/list subspace.
    SiteUrls.prototype.allUsersListUrl = function () {
        return this.fullUrl(this.allUsersListPath());
    };
    SiteUrls.prototype.allUsersListPath = function () {
        return this.usersPath() + SiteUrls.allUsersListPart();
    };
    SiteUrls.allUsersListPart = function () {
        return '/list';
    };
    // While the user identity migration is in process, we have an identity subspace for users.
    SiteUrls.prototype.allUserIdentitiesUrl = function () {
        return this.fullUrl(this.allUserIdentitiesPath());
    };
    SiteUrls.prototype.allUserIdentitiesPath = function () {
        return this.usersPath() + SiteUrls.allUserIdentitiesPart();
    };
    SiteUrls.allUserIdentitiesPart = function () {
        return '/identities';
    };
    SiteUrls.prototype.baseUserUrl = function () {
        return this.fullUrl(this.baseUserPath());
    };
    SiteUrls.prototype.baseUserPath = function () {
        return this.sitePath(SiteUrls.baseUserPart());
    };
    SiteUrls.baseUserPart = function () {
        return "/user";
    };
    SiteUrls.prototype.userUrl = function (username, domainName) {
        return this.fullUrl(this.userPath(username, domainName));
    };
    SiteUrls.prototype.userPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userPart(username, domainName));
    };
    SiteUrls.userPart = function (username, domainName) {
        return util_1.encodePath("/user/" + domainName + "/" + username);
    };
    SiteUrls.prototype.userContentUrl = function (username, domainName) {
        return this.fullUrl(this.userContentPath(username, domainName));
    };
    SiteUrls.prototype.userContentPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userContentPart(username, domainName));
    };
    SiteUrls.userContentPart = function (username, domainName) {
        return "" + SiteUrls.userPart(username, domainName) + SiteUrls.contentPart();
    };
    SiteUrls.contentPart = function () {
        return '/content';
    };
    SiteUrls.prototype.userDataAlertsUrl = function (username, domainName) {
        return this.fullUrl(this.userDataAlertsPath(username, domainName));
    };
    SiteUrls.prototype.userDataAlertsPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userDataAlertsPart(username, domainName));
    };
    SiteUrls.userDataAlertsPart = function (username, domainName) {
        return "" + SiteUrls.userPart(username, domainName) + SiteUrls.dataAlertsPart();
    };
    SiteUrls.dataAlertsPart = function () {
        return '/dataAlerts';
    };
    SiteUrls.prototype.userSubscriptionsUrl = function (username, domainName) {
        return this.fullUrl(this.userSubscriptionsPath(username, domainName));
    };
    SiteUrls.prototype.userSubscriptionsPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userSubscriptionsPart(username, domainName));
    };
    SiteUrls.userSubscriptionsPart = function (username, domainName) {
        return "" + SiteUrls.userPart(username, domainName) + SiteUrls.subscriptionsPart();
    };
    SiteUrls.prototype.userCollectionsUrl = function (username, domainName) {
        return this.fullUrl(this.userCollectionsPath(username, domainName));
    };
    SiteUrls.prototype.userCollectionsPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userCollectionsPart(username, domainName));
    };
    SiteUrls.userCollectionsPart = function (username, domainName) {
        return "" + SiteUrls.userPart(username, domainName) + SiteUrls.collectionsPath();
    };
    SiteUrls.prototype.userSettingsUrl = function (username, domainName) {
        return this.fullUrl(this.userSettingsPath(username, domainName));
    };
    SiteUrls.prototype.userSettingsPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userSettingsPart(username, domainName));
    };
    SiteUrls.userSettingsPart = function (username, domainName) {
        return "" + SiteUrls.userPart(username, domainName) + SiteUrls.settingsPart();
    };
    // Legacy support user urls: projects, workbooks, views, metrics, datasources. flows
    // for supporting previously bookmarked urls. no new user subspaces should be added here
    SiteUrls.prototype.userProjectsUrl = function (username, domainName) {
        return this.fullUrl(this.userProjectsPath(username, domainName));
    };
    SiteUrls.prototype.userProjectsPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userProjectsPart(username, domainName));
    };
    SiteUrls.userProjectsPart = function (username, domainName) {
        return "" + SiteUrls.userPart(username, domainName) + SiteUrls.projectsPart();
    };
    SiteUrls.prototype.userWorkbooksUrl = function (username, domainName) {
        return this.fullUrl(this.userWorkbooksPath(username, domainName));
    };
    SiteUrls.prototype.userWorkbooksPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userWorkbooksPart(username, domainName));
    };
    SiteUrls.userWorkbooksPart = function (username, domainName) {
        return "" + SiteUrls.userPart(username, domainName) + SiteUrls.workbooksPart();
    };
    SiteUrls.prototype.userViewsUrl = function (username, domainName) {
        return this.fullUrl(this.userViewsPath(username, domainName));
    };
    SiteUrls.prototype.userViewsPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userViewsPart(username, domainName));
    };
    SiteUrls.userViewsPart = function (username, domainName) {
        return "" + SiteUrls.userPart(username, domainName) + SiteUrls.viewsPart();
    };
    SiteUrls.prototype.userMetricsUrl = function (username, domainName) {
        return this.fullUrl(this.userMetricsPath(username, domainName));
    };
    SiteUrls.prototype.userMetricsPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userMetricsPart(username, domainName));
    };
    SiteUrls.userMetricsPart = function (username, domainName) {
        return "" + SiteUrls.userPart(username, domainName) + SiteUrls.metricsPart();
    };
    SiteUrls.prototype.userDatasourcesUrl = function (username, domainName) {
        return this.fullUrl(this.userDatasourcesPath(username, domainName));
    };
    SiteUrls.prototype.userDatasourcesPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userDatasourcesPart(username, domainName));
    };
    SiteUrls.userDatasourcesPart = function (username, domainName) {
        return "" + SiteUrls.userPart(username, domainName) + SiteUrls.datasourcesPart();
    };
    SiteUrls.prototype.userFlowsUrl = function (username, domainName) {
        return this.fullUrl(this.userFlowsPath(username, domainName));
    };
    SiteUrls.prototype.userFlowsPath = function (username, domainName) {
        return this.sitePath(SiteUrls.userFlowsPart(username, domainName));
    };
    SiteUrls.userFlowsPart = function (username, domainName) {
        return "" + SiteUrls.userPart(username, domainName) + SiteUrls.flowsPart();
    };
    // Data Sources
    SiteUrls.prototype.datasourcesUrl = function () {
        return this.fullUrl(this.datasourcesPath());
    };
    SiteUrls.prototype.datasourcesPath = function () {
        return this.sitePath(SiteUrls.datasourcesPart());
    };
    SiteUrls.datasourcesPart = function () {
        return '/datasources';
    };
    SiteUrls.prototype.datasourcesWithTagUrl = function (tag) {
        return this.fullUrl(this.datasourcesWithTagPath(tag));
    };
    SiteUrls.prototype.datasourcesWithTagPath = function (tag) {
        return this.sitePath(SiteUrls.datasourcesWithTagPart(tag));
    };
    SiteUrls.datasourcesWithTagPart = function (tag) {
        return "" + SiteUrls.datasourcesPart() + SiteUrls.tagPart(tag);
    };
    SiteUrls.prototype.datasourceUrl = function (datasourceId) {
        return this.fullUrl(this.datasourcePath(datasourceId));
    };
    SiteUrls.prototype.datasourcePath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourcePart(datasourceId));
    };
    SiteUrls.datasourcePart = function (datasourceId) {
        return SiteUrls.datasourcesPart() + "/" + datasourceId;
    };
    SiteUrls.prototype.exploreDatasourceUrl = function (datasourceId) {
        return this.fullUrl(this.exploreDatasourcePath(datasourceId));
    };
    SiteUrls.prototype.exploreDatasourcePath = function (datasourceId) {
        return this.sitePath(SiteUrls.exploreDatasourcePart(datasourceId));
    };
    SiteUrls.exploreDatasourcePart = function (datasourceId) {
        return "/explore/datasource/" + datasourceId;
    };
    SiteUrls.prototype.datasourcePublishresultUrl = function (datasourceId) {
        return this.fullUrl(this.datasourcePublishresultPath(datasourceId));
    };
    SiteUrls.prototype.datasourcePublishresultPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourcePublishresultPart(datasourceId));
    };
    SiteUrls.datasourcePublishresultPart = function (datasourceId) {
        return "" + SiteUrls.datasourcePart(datasourceId) + SiteUrls.publishresultPart();
    };
    SiteUrls.prototype.datasourceAskDataUsageAnalyticsUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceAskDataUsageAnalyticsPath(datasourceId));
    };
    SiteUrls.prototype.datasourceAskDataUsageAnalyticsPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceAskDataUsageAnalyticsPart(datasourceId));
    };
    SiteUrls.datasourceAskDataUsageAnalyticsPart = function (datasourceId) {
        return "" + SiteUrls.datasourcePart(datasourceId) + SiteUrls.askDataUsageAnalyticsPart();
    };
    SiteUrls.askDataUsageAnalyticsPart = function () {
        return '/askDataUsageAnalytics';
    };
    SiteUrls.prototype.datasourceAskDataUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceAskDataPath(datasourceId));
    };
    SiteUrls.prototype.datasourceAskDataPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceAskDataPart(datasourceId));
    };
    SiteUrls.datasourceAskDataPart = function (datasourceId) {
        return "" + SiteUrls.datasourcePart(datasourceId) + SiteUrls.askDataPart();
    };
    SiteUrls.askDataPart = function () {
        return '/askData';
    };
    SiteUrls.prototype.datasourceConnectionsUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceConnectionsPath(datasourceId));
    };
    SiteUrls.prototype.datasourceConnectionsPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceConnectionsPart(datasourceId));
    };
    SiteUrls.datasourceConnectionsPart = function (datasourceId) {
        return "" + SiteUrls.datasourcePart(datasourceId) + SiteUrls.connectionsPart();
    };
    SiteUrls.prototype.datasourceExtractRefreshesUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceExtractRefreshesPath(datasourceId));
    };
    SiteUrls.prototype.datasourceExtractRefreshesPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceExtractRefreshesPart(datasourceId));
    };
    SiteUrls.datasourceExtractRefreshesPart = function (datasourceId) {
        return "" + SiteUrls.datasourcePart(datasourceId) + SiteUrls.extractRefreshesPart();
    };
    SiteUrls.prototype.datasourceLocalExtractRefreshesUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLocalExtractRefreshesPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLocalExtractRefreshesPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLocalExtractRefreshesPart(datasourceId));
    };
    SiteUrls.datasourceLocalExtractRefreshesPart = function (datasourceId) {
        return "" + SiteUrls.datasourcePart(datasourceId) + SiteUrls.localExtractRefreshesPart();
    };
    SiteUrls.localExtractRefreshesPart = function () {
        return '/localExtractRefreshes';
    };
    SiteUrls.prototype.datasourceConnectedWorkbooksUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceConnectedWorkbooksPath(datasourceId));
    };
    SiteUrls.prototype.datasourceConnectedWorkbooksPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceConnectedWorkbooksPart(datasourceId));
    };
    SiteUrls.datasourceConnectedWorkbooksPart = function (datasourceId) {
        return "" + SiteUrls.datasourcePart(datasourceId) + SiteUrls.connectedWorkbooksPart();
    };
    SiteUrls.connectedWorkbooksPart = function () {
        return '/connectedWorkbooks';
    };
    SiteUrls.prototype.datasourceDetailsUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceDetailsPath(datasourceId));
    };
    SiteUrls.prototype.datasourceDetailsPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceDetailsPart(datasourceId));
    };
    SiteUrls.datasourceDetailsPart = function (datasourceId) {
        return "" + SiteUrls.datasourcePart(datasourceId) + SiteUrls.detailsPart();
    };
    SiteUrls.detailsPart = function () {
        return '/details';
    };
    SiteUrls.prototype.datasourceDataConnectionUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceDataConnectionPath(datasourceId));
    };
    SiteUrls.prototype.datasourceDataConnectionPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceDataConnectionPart(datasourceId));
    };
    SiteUrls.datasourceDataConnectionPart = function (datasourceId) {
        return "" + SiteUrls.datasourcePart(datasourceId) + SiteUrls.dataConnectionPart();
    };
    SiteUrls.dataConnectionPart = function () {
        return '/dataConnection';
    };
    SiteUrls.prototype.favoriteDatasourceUrl = function (datasourceId, datasourceIdForFavoriting) {
        return this.fullUrl(this.favoriteDatasourcePath(datasourceId, datasourceIdForFavoriting));
    };
    SiteUrls.prototype.favoriteDatasourcePath = function (datasourceId, datasourceIdForFavoriting) {
        return this.sitePath(SiteUrls.favoriteDatasourcePart(datasourceId, datasourceIdForFavoriting));
    };
    SiteUrls.favoriteDatasourcePart = function (datasourceId, datasourceIdForFavoriting) {
        return "/redirect_to_datasource/" + datasourceIdForFavoriting + "/" + datasourceId;
    };
    SiteUrls.prototype.favoriteDatasourceDoesntExistUrl = function (datasourceIdForFavoriting) {
        return this.fullUrl(this.favoriteDatasourceDoesntExistPath(datasourceIdForFavoriting));
    };
    SiteUrls.prototype.favoriteDatasourceDoesntExistPath = function (datasourceIdForFavoriting) {
        return this.sitePath(SiteUrls.favoriteDatasourceDoesntExistPart(datasourceIdForFavoriting));
    };
    SiteUrls.favoriteDatasourceDoesntExistPart = function (datasourceIdForFavoriting) {
        return "/redirect_to_removed_datasource/" + datasourceIdForFavoriting;
    };
    SiteUrls.prototype.datasourceLineageUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineagePath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineagePath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineagePart(datasourceId));
    };
    SiteUrls.datasourceLineagePart = function (datasourceId) {
        return "" + SiteUrls.datasourcePart(datasourceId) + SiteUrls.lineagePart();
    };
    SiteUrls.prototype.datasourceLineageFieldsUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageFieldsPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageFieldsPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageFieldsPart(datasourceId));
    };
    SiteUrls.datasourceLineageFieldsPart = function (datasourceId) {
        return "" + SiteUrls.datasourceLineagePart(datasourceId) + SiteUrls.fieldsPart();
    };
    SiteUrls.prototype.datasourceLineageFieldUrl = function (datasourceId, fieldId) {
        return this.fullUrl(this.datasourceLineageFieldPath(datasourceId, fieldId));
    };
    SiteUrls.prototype.datasourceLineageFieldPath = function (datasourceId, fieldId) {
        return this.sitePath(SiteUrls.datasourceLineageFieldPart(datasourceId, fieldId));
    };
    SiteUrls.datasourceLineageFieldPart = function (datasourceId, fieldId) {
        return "" + SiteUrls.datasourceLineagePart(datasourceId) + SiteUrls.fieldsPart() + "/" + fieldId;
    };
    SiteUrls.prototype.datasourceLineageUpstreamDatabasesUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageUpstreamDatabasesPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageUpstreamDatabasesPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageUpstreamDatabasesPart(datasourceId));
    };
    SiteUrls.datasourceLineageUpstreamDatabasesPart = function (datasourceId) {
        return "" + SiteUrls.datasourceLineagePart(datasourceId) + SiteUrls.upstreamPart() + SiteUrls.databasesPart();
    };
    SiteUrls.prototype.datasourceLineageUpstreamTablesUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageUpstreamTablesPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageUpstreamTablesPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageUpstreamTablesPart(datasourceId));
    };
    SiteUrls.datasourceLineageUpstreamTablesPart = function (datasourceId) {
        return "" + SiteUrls.datasourceLineagePart(datasourceId) + SiteUrls.upstreamPart() + SiteUrls.tablesPart();
    };
    SiteUrls.prototype.datasourceLineageUpstreamFlowsUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageUpstreamFlowsPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageUpstreamFlowsPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageUpstreamFlowsPart(datasourceId));
    };
    SiteUrls.datasourceLineageUpstreamFlowsPart = function (datasourceId) {
        return "" + SiteUrls.datasourceLineagePart(datasourceId) + SiteUrls.upstreamPart() + SiteUrls.flowsPart();
    };
    SiteUrls.prototype.datasourceLineageUpstreamDatasourcesUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageUpstreamDatasourcesPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageUpstreamDatasourcesPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageUpstreamDatasourcesPart(datasourceId));
    };
    SiteUrls.datasourceLineageUpstreamDatasourcesPart = function (datasourceId) {
        return "" + SiteUrls.datasourceLineagePart(datasourceId) + SiteUrls.upstreamPart() + SiteUrls.datasourcesPart();
    };
    SiteUrls.prototype.datasourceLineageDownstreamDatabasesUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageDownstreamDatabasesPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageDownstreamDatabasesPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageDownstreamDatabasesPart(datasourceId));
    };
    SiteUrls.datasourceLineageDownstreamDatabasesPart = function (datasourceId) {
        return "" + SiteUrls.datasourceLineagePart(datasourceId) + SiteUrls.downstreamPart() + SiteUrls.databasesPart();
    };
    SiteUrls.prototype.datasourceLineageDownstreamTablesUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageDownstreamTablesPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageDownstreamTablesPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageDownstreamTablesPart(datasourceId));
    };
    SiteUrls.datasourceLineageDownstreamTablesPart = function (datasourceId) {
        return "" + SiteUrls.datasourceLineagePart(datasourceId) + SiteUrls.downstreamPart() + SiteUrls.tablesPart();
    };
    SiteUrls.prototype.datasourceLineageDownstreamFlowsUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageDownstreamFlowsPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageDownstreamFlowsPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageDownstreamFlowsPart(datasourceId));
    };
    SiteUrls.datasourceLineageDownstreamFlowsPart = function (datasourceId) {
        return "" + SiteUrls.datasourceLineagePart(datasourceId) + SiteUrls.downstreamPart() + SiteUrls.flowsPart();
    };
    SiteUrls.prototype.datasourceLineageDownstreamDatasourcesUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageDownstreamDatasourcesPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageDownstreamDatasourcesPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageDownstreamDatasourcesPart(datasourceId));
    };
    SiteUrls.datasourceLineageDownstreamDatasourcesPart = function (datasourceId) {
        return "" + SiteUrls.datasourceLineagePart(datasourceId) + SiteUrls.downstreamPart() + SiteUrls.datasourcesPart();
    };
    SiteUrls.prototype.datasourceLineageDownstreamWorkbooksUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageDownstreamWorkbooksPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageDownstreamWorkbooksPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageDownstreamWorkbooksPart(datasourceId));
    };
    SiteUrls.datasourceLineageDownstreamWorkbooksPart = function (datasourceId) {
        return "" + SiteUrls.datasourceLineagePart(datasourceId) + SiteUrls.downstreamPart() + SiteUrls.workbooksPart();
    };
    SiteUrls.prototype.datasourceLineageDownstreamDashboardsUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageDownstreamDashboardsPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageDownstreamDashboardsPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageDownstreamDashboardsPart(datasourceId));
    };
    SiteUrls.datasourceLineageDownstreamDashboardsPart = function (datasourceId) {
        return "" + SiteUrls.datasourceLineagePart(datasourceId) + SiteUrls.downstreamPart() + SiteUrls.dashboardsPart();
    };
    SiteUrls.prototype.datasourceLineageDownstreamSheetsUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageDownstreamSheetsPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageDownstreamSheetsPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageDownstreamSheetsPart(datasourceId));
    };
    SiteUrls.datasourceLineageDownstreamSheetsPart = function (datasourceId) {
        return "" + SiteUrls.datasourceLineagePart(datasourceId) + SiteUrls.downstreamPart() + SiteUrls.sheetsPart();
    };
    SiteUrls.prototype.datasourceLineageDownstreaMetricsUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageDownstreamMetricsPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageDownstreamMetricsPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageDownstreamMetricsPart(datasourceId));
    };
    SiteUrls.datasourceLineageDownstreamMetricsPart = function (datasourceId) {
        return "" + SiteUrls.datasourceLineagePart(datasourceId) + SiteUrls.downstreamPart() + SiteUrls.lineageMetricsPart();
    };
    SiteUrls.prototype.datasourceLineageDownstreamOwnersUrl = function (datasourceId) {
        return this.fullUrl(this.datasourceLineageDownstreamOwnersPath(datasourceId));
    };
    SiteUrls.prototype.datasourceLineageDownstreamOwnersPath = function (datasourceId) {
        return this.sitePath(SiteUrls.datasourceLineageDownstreamOwnersPart(datasourceId));
    };
    SiteUrls.datasourceLineageDownstreamOwnersPart = function (datasourceId) {
        return "" + SiteUrls.datasourceLineagePart(datasourceId) + SiteUrls.downstreamPart() + SiteUrls.ownersPart();
    };
    // Groups
    SiteUrls.prototype.groupsUrl = function () {
        return this.fullUrl(this.groupsPath());
    };
    SiteUrls.prototype.groupsPath = function () {
        return this.sitePath(SiteUrls.groupsPart());
    };
    SiteUrls.groupsPart = function () {
        return '/groups';
    };
    SiteUrls.prototype.groupUrl = function (groupId) {
        return this.fullUrl(this.groupPath(groupId));
    };
    SiteUrls.prototype.groupPath = function (groupId) {
        return this.sitePath(SiteUrls.groupPart(groupId));
    };
    SiteUrls.groupPart = function (groupId) {
        return SiteUrls.groupsPart() + "/" + groupId;
    };
    SiteUrls.prototype.groupUsersUrl = function (groupId) {
        return this.fullUrl(this.groupUsersPath(groupId));
    };
    SiteUrls.prototype.groupUsersPath = function (groupId) {
        return this.sitePath(SiteUrls.groupUsersPart(groupId));
    };
    SiteUrls.groupUsersPart = function (groupId) {
        return "" + SiteUrls.groupPart(groupId) + SiteUrls.usersPart();
    };
    SiteUrls.prototype.groupDetailsUrl = function (groupId) {
        return this.fullUrl(this.groupDetailsPath(groupId));
    };
    SiteUrls.prototype.groupDetailsPath = function (groupId) {
        return this.sitePath(SiteUrls.groupDetailsPart(groupId));
    };
    SiteUrls.groupDetailsPart = function (groupId) {
        return "" + SiteUrls.groupPart(groupId) + SiteUrls.detailsPart();
    };
    // Schedules
    SiteUrls.prototype.schedulesUrl = function () {
        return this.fullUrl(this.schedulesPath());
    };
    SiteUrls.prototype.schedulesPath = function () {
        return this.sitePath(SiteUrls.schedulesPart());
    };
    SiteUrls.schedulesPart = function () {
        return '/schedules';
    };
    SiteUrls.prototype.scheduleUrl = function (scheduleId) {
        return this.fullUrl(this.schedulePath(scheduleId));
    };
    SiteUrls.prototype.schedulePath = function (scheduleId) {
        return this.sitePath(SiteUrls.schedulePart(scheduleId));
    };
    SiteUrls.schedulePart = function (scheduleId) {
        return SiteUrls.schedulesPart() + "/" + scheduleId;
    };
    // public scheduleExtractRefreshesUrl(scheduleId: string): string {
    //   return this.scheduleUrl(scheduleId) + '/extractRefreshes';
    // }
    SiteUrls.prototype.scheduleExtractRefreshesUrl = function (scheduleId) {
        return this.fullUrl(this.scheduleExtractRefreshesPath(scheduleId));
    };
    SiteUrls.prototype.scheduleExtractRefreshesPath = function (scheduleId) {
        return this.sitePath(SiteUrls.scheduleExtractRefreshesPart(scheduleId));
    };
    SiteUrls.scheduleExtractRefreshesPart = function (scheduleId) {
        return "" + SiteUrls.schedulePart(scheduleId) + SiteUrls.extractRefreshesPart();
    };
    SiteUrls.extractRefreshesPart = function () {
        return '/extractRefreshes';
    };
    SiteUrls.prototype.scheduleFlowsUrl = function (scheduleId) {
        return this.fullUrl(this.scheduleFlowsPath(scheduleId));
    };
    SiteUrls.prototype.scheduleFlowsPath = function (scheduleId) {
        return this.sitePath(SiteUrls.scheduleFlowsPart(scheduleId));
    };
    SiteUrls.scheduleFlowsPart = function (scheduleId) {
        return "" + SiteUrls.schedulePart(scheduleId) + SiteUrls.flowsPart();
    };
    SiteUrls.prototype.scheduleSubscriptionsUrl = function (scheduleId) {
        return this.fullUrl(this.scheduleSubscriptionsPath(scheduleId));
    };
    SiteUrls.prototype.scheduleSubscriptionsPath = function (scheduleId) {
        return this.sitePath(SiteUrls.scheduleSubscriptionsPart(scheduleId));
    };
    SiteUrls.scheduleSubscriptionsPart = function (scheduleId) {
        return "" + SiteUrls.schedulePart(scheduleId) + SiteUrls.subscriptionsPart();
    };
    SiteUrls.subscriptionsPart = function () {
        return '/subscriptions';
    };
    SiteUrls.prototype.scheduleDataAccelerationUrl = function (scheduleId) {
        return this.fullUrl(this.scheduleDataAccelerationPath(scheduleId));
    };
    SiteUrls.prototype.scheduleDataAccelerationPath = function (scheduleId) {
        return this.sitePath(SiteUrls.scheduleDataAccelerationPart(scheduleId));
    };
    SiteUrls.scheduleDataAccelerationPart = function (scheduleId) {
        return "" + SiteUrls.schedulePart(scheduleId) + SiteUrls.dataAccelerationPart();
    };
    SiteUrls.prototype.scheduleDetailsUrl = function (scheduleId) {
        return this.fullUrl(this.scheduleDetailsPath(scheduleId));
    };
    SiteUrls.prototype.scheduleDetailsPath = function (scheduleId) {
        return this.sitePath(SiteUrls.scheduleDetailsPart(scheduleId));
    };
    SiteUrls.scheduleDetailsPart = function (scheduleId) {
        return "" + SiteUrls.schedulePart(scheduleId) + SiteUrls.detailsPart();
    };
    // Jobs
    SiteUrls.prototype.jobsUrl = function () {
        return this.fullUrl(this.jobsPath());
    };
    SiteUrls.prototype.jobsPath = function () {
        return this.sitePath(SiteUrls.jobsPart());
    };
    SiteUrls.jobsPart = function () {
        return '/jobs';
    };
    // Favorites
    SiteUrls.prototype.favoritesUrl = function () {
        return this.fullUrl(this.favoritesPath());
    };
    SiteUrls.prototype.favoritesPath = function () {
        return this.sitePath(SiteUrls.favoritesPart());
    };
    SiteUrls.favoritesPart = function () {
        return '/favorites';
    };
    // Recents
    SiteUrls.prototype.recentsUrl = function () {
        return this.fullUrl(this.recentsPath());
    };
    SiteUrls.prototype.recentsPath = function () {
        return this.sitePath(SiteUrls.recentsPart());
    };
    SiteUrls.recentsPart = function () {
        return '/recents';
    };
    // search
    SiteUrls.prototype.searchUrl = function () {
        return this.fullUrl(this.searchPath());
    };
    SiteUrls.prototype.searchPath = function () {
        return this.sitePath(SiteUrls.searchPart());
    };
    SiteUrls.searchPart = function () {
        return '/search';
    };
    SiteUrls.prototype.searchViewsUrl = function () {
        return this.fullUrl(this.searchViewsPath());
    };
    SiteUrls.prototype.searchViewsPath = function () {
        return this.sitePath(SiteUrls.searchViewsPart());
    };
    SiteUrls.searchViewsPart = function () {
        return "" + SiteUrls.searchPart() + SiteUrls.viewsPart();
    };
    SiteUrls.prototype.searchMetricsUrl = function () {
        return this.fullUrl(this.searchMetricsPath());
    };
    SiteUrls.prototype.searchMetricsPath = function () {
        return this.sitePath(SiteUrls.searchMetricsPart());
    };
    SiteUrls.searchMetricsPart = function () {
        return "" + SiteUrls.searchPart() + SiteUrls.metricsPart();
    };
    SiteUrls.prototype.searchWorkbooksUrl = function () {
        return this.fullUrl(this.searchWorkbooksPath());
    };
    SiteUrls.prototype.searchWorkbooksPath = function () {
        return this.sitePath(SiteUrls.searchWorkbooksPart());
    };
    SiteUrls.searchWorkbooksPart = function () {
        return "" + SiteUrls.searchPart() + SiteUrls.workbooksPart();
    };
    SiteUrls.prototype.searchDatasourcesUrl = function () {
        return this.fullUrl(this.searchDatasourcesPath());
    };
    SiteUrls.prototype.searchDatasourcesPath = function () {
        return this.sitePath(SiteUrls.searchDatasourcesPart());
    };
    SiteUrls.searchDatasourcesPart = function () {
        return "" + SiteUrls.searchPart() + SiteUrls.datasourcesPart();
    };
    SiteUrls.prototype.searchProjectsUrl = function () {
        return this.fullUrl(this.searchProjectsPath());
    };
    SiteUrls.prototype.searchProjectsPath = function () {
        return this.sitePath(SiteUrls.searchProjectsPart());
    };
    SiteUrls.searchProjectsPart = function () {
        return "" + SiteUrls.searchPart() + SiteUrls.projectsPart();
    };
    SiteUrls.prototype.searchFlowsUrl = function () {
        return this.fullUrl(this.searchFlowsPath());
    };
    SiteUrls.prototype.searchFlowsPath = function () {
        return this.sitePath(SiteUrls.searchFlowsPart());
    };
    SiteUrls.searchFlowsPart = function () {
        return "" + SiteUrls.searchPart() + SiteUrls.flowsPart();
    };
    SiteUrls.prototype.searchTablesUrl = function () {
        return this.fullUrl(this.searchTablesPath());
    };
    SiteUrls.prototype.searchTablesPath = function () {
        return this.sitePath(SiteUrls.searchTablesPart());
    };
    SiteUrls.searchTablesPart = function () {
        return "" + SiteUrls.searchPart() + SiteUrls.tablesPart();
    };
    SiteUrls.prototype.searchDatabasesUrl = function () {
        return this.fullUrl(this.searchDatabasesPath());
    };
    SiteUrls.prototype.searchDatabasesPath = function () {
        return this.sitePath(SiteUrls.searchDatabasesPart());
    };
    SiteUrls.searchDatabasesPart = function () {
        return "" + SiteUrls.searchPart() + SiteUrls.databasesPart();
    };
    SiteUrls.prototype.searchDataRolesUrl = function () {
        return this.fullUrl(this.searchDataRolesPath());
    };
    SiteUrls.prototype.searchDataRolesPath = function () {
        return this.sitePath(SiteUrls.searchDataRolesPart());
    };
    SiteUrls.searchDataRolesPart = function () {
        return "" + SiteUrls.searchPart() + SiteUrls.dataRolesPart();
    };
    SiteUrls.prototype.searchLensesUrl = function () {
        return this.fullUrl(this.searchLensesPath());
    };
    SiteUrls.prototype.searchLensesPath = function () {
        return this.sitePath(SiteUrls.searchLensesPart());
    };
    SiteUrls.searchLensesPart = function () {
        return "" + SiteUrls.searchPart() + SiteUrls.lensesPart();
    };
    SiteUrls.prototype.searchUsersUrl = function () {
        return this.fullUrl(this.searchUsersPath());
    };
    SiteUrls.prototype.searchUsersPath = function () {
        return this.sitePath(SiteUrls.searchUsersPart());
    };
    SiteUrls.searchUsersPart = function () {
        return "" + SiteUrls.searchPart() + SiteUrls.usersPart();
    };
    SiteUrls.prototype.searchPublishedConnectionsUrl = function () {
        return this.fullUrl(this.searchPublishedConnectionsPath());
    };
    SiteUrls.prototype.searchPublishedConnectionsPath = function () {
        return this.sitePath(SiteUrls.searchPublishedConnectionsPart());
    };
    SiteUrls.searchPublishedConnectionsPart = function () {
        return "" + SiteUrls.searchPart() + SiteUrls.publishedConnectionsPart();
    };
    // Others
    SiteUrls.prototype.settingsUrl = function () {
        return this.fullUrl(this.settingsPath());
    };
    SiteUrls.prototype.settingsPath = function () {
        return this.sitePath(SiteUrls.settingsPart());
    };
    SiteUrls.settingsPart = function () {
        return '/settings';
    };
    SiteUrls.prototype.settingsAuthenticationUrl = function () {
        return this.fullUrl(this.settingsAuthenticationPath());
    };
    SiteUrls.prototype.settingsAuthenticationPath = function () {
        return this.sitePath(SiteUrls.authenticationPart());
    };
    SiteUrls.authenticationPart = function () {
        return '/authentication';
    };
    SiteUrls.prototype.settingsBridgeUrl = function () {
        return this.fullUrl(this.settingsBridgePath());
    };
    SiteUrls.prototype.settingsBridgePath = function () {
        return this.sitePath(SiteUrls.bridgePart());
    };
    SiteUrls.bridgePart = function () {
        return '/bridge';
    };
    SiteUrls.prototype.settingsExtensionsUrl = function () {
        return this.fullUrl(this.settingsExtensionsPath());
    };
    SiteUrls.prototype.settingsExtensionsPath = function () {
        return this.sitePath(SiteUrls.extensionsPart());
    };
    SiteUrls.extensionsPart = function () {
        return '/extensions';
    };
    SiteUrls.prototype.settingsIntegrationsUrl = function () {
        return this.fullUrl(this.settingsIntegrationsPath());
    };
    SiteUrls.prototype.settingsIntegrationsPath = function () {
        return this.sitePath(SiteUrls.integrationsPart());
    };
    SiteUrls.integrationsPart = function () {
        return '/integrations';
    };
    SiteUrls.prototype.statusUrl = function () {
        return this.fullUrl(this.statusPath());
    };
    SiteUrls.prototype.statusPath = function () {
        return this.sitePath(SiteUrls.statusPart());
    };
    SiteUrls.statusPart = function () {
        return '/status';
    };
    // Tasks
    SiteUrls.prototype.tasksUrl = function () {
        return this.fullUrl(this.tasksPath());
    };
    SiteUrls.prototype.tasksPath = function () {
        return this.sitePath(SiteUrls.tasksPart());
    };
    SiteUrls.tasksPart = function () {
        return '/tasks';
    };
    SiteUrls.prototype.tasksExtractRefreshesUrl = function () {
        return this.fullUrl(this.tasksExtractRefreshesPath());
    };
    SiteUrls.prototype.tasksExtractRefreshesPath = function () {
        return this.sitePath(SiteUrls.tasksExtractRefreshesPart());
    };
    SiteUrls.tasksExtractRefreshesPart = function () {
        return "" + SiteUrls.tasksPart() + SiteUrls.extractRefreshesPart();
    };
    SiteUrls.prototype.tasksFlowsUrl = function () {
        return this.fullUrl(this.tasksFlowsPath());
    };
    SiteUrls.prototype.tasksFlowsPath = function () {
        return this.sitePath(SiteUrls.tasksFlowsPart());
    };
    SiteUrls.tasksFlowsPart = function () {
        return "" + SiteUrls.tasksPart() + SiteUrls.flowsPart();
    };
    SiteUrls.prototype.tasksSubscriptionsUrl = function () {
        return this.fullUrl(this.tasksSubscriptionsPath());
    };
    SiteUrls.prototype.tasksSubscriptionsPath = function () {
        return this.sitePath(SiteUrls.tasksSubscriptionsPart());
    };
    SiteUrls.tasksSubscriptionsPart = function () {
        return "" + SiteUrls.tasksPart() + SiteUrls.subscriptionsPart();
    };
    SiteUrls.prototype.tasksDataAlertsUrl = function () {
        return this.fullUrl(this.tasksDataAlertsPath());
    };
    SiteUrls.prototype.tasksDataAlertsPath = function () {
        return this.sitePath(SiteUrls.tasksDataAlertsPart());
    };
    SiteUrls.tasksDataAlertsPart = function () {
        return "" + SiteUrls.tasksPart() + SiteUrls.dataAlertsPart();
    };
    SiteUrls.prototype.tasksDataAccelerationUrl = function () {
        return this.fullUrl(this.tasksDataAccelerationPath());
    };
    SiteUrls.prototype.tasksDataAccelerationPath = function () {
        return this.sitePath(SiteUrls.tasksDataAccelerationPart());
    };
    SiteUrls.tasksDataAccelerationPart = function () {
        return "" + SiteUrls.tasksPart() + SiteUrls.dataAccelerationPart();
    };
    SiteUrls.dataAccelerationPart = function () {
        return '/dataAcceleration';
    };
    SiteUrls.prototype.tasksLinkedTasksUrl = function () {
        return this.fullUrl(this.tasksLinkedTasksPath());
    };
    SiteUrls.prototype.tasksLinkedTasksPath = function () {
        return this.sitePath(SiteUrls.tasksLinkedTasksPart());
    };
    SiteUrls.tasksLinkedTasksPart = function () {
        return "" + SiteUrls.tasksPart() + SiteUrls.linkedTasksPart();
    };
    SiteUrls.linkedTasksPart = function () {
        return '/linkedTasks';
    };
    // Home
    SiteUrls.prototype.homeUrl = function () {
        return this.fullUrl(this.homePath());
    };
    SiteUrls.prototype.homePath = function () {
        return this.sitePath(SiteUrls.homePart());
    };
    SiteUrls.homePart = function () {
        return '/home';
    };
    // Sandbox
    SiteUrls.prototype.sandboxUrl = function () {
        return this.fullUrl(this.sandboxPath());
    };
    SiteUrls.prototype.sandboxPath = function () {
        return this.sitePath(SiteUrls.sandboxPart());
    };
    SiteUrls.sandboxPart = function () {
        return '/sandbox';
    };
    // Metrics
    SiteUrls.prototype.metricsUrl = function () {
        return this.fullUrl(this.metricsPath());
    };
    SiteUrls.prototype.metricsPath = function () {
        return this.sitePath(SiteUrls.metricsPart());
    };
    SiteUrls.metricsPart = function () {
        return '/metrics';
    };
    SiteUrls.prototype.metricUrl = function (metricId) {
        return this.fullUrl(this.metricPath(metricId));
    };
    SiteUrls.prototype.metricPath = function (metricId) {
        return this.sitePath(SiteUrls.metricPart(metricId));
    };
    SiteUrls.metricPart = function (metricId) {
        return SiteUrls.metricsPart() + "/" + metricId;
    };
    SiteUrls.prototype.favoriteMetricUrl = function (metricId) {
        return this.redirectToMetricUrl(metricId);
    };
    SiteUrls.prototype.redirectToMetricUrl = function (metricId) {
        return this.fullUrl(this.redirectToMetricPath(metricId));
    };
    SiteUrls.prototype.redirectToMetricPath = function (metricId) {
        return this.sitePath(SiteUrls.redirectToMetricPart(metricId));
    };
    SiteUrls.redirectToMetricPart = function (metricId) {
        return "/redirect_to_metric/" + metricId;
    };
    // Site Status Vizzes
    SiteUrls.prototype.siteStatusVizUrl = function (sheetUrlId) {
        return this.fullUrl(this.siteStatusVizPath(sheetUrlId));
    };
    SiteUrls.prototype.siteStatusVizPath = function (sheetUrlId) {
        return this.sitePath(SiteUrls.siteStatusVizPart(sheetUrlId));
    };
    SiteUrls.siteStatusVizPart = function (sheetUrlId) {
        return "/analysis/" + sheetUrlId;
    };
    // Workbook Revision History
    SiteUrls.prototype.workbookRevisionHistoryUrl = function (params) {
        return this.fullUrl(this.workbookRevisionHistoryPath(params));
    };
    SiteUrls.prototype.workbookRevisionHistoryPath = function (params) {
        return this.sitePath(SiteUrls.workbookRevisionHistoryPart(params));
    };
    SiteUrls.workbookRevisionHistoryPart = function (params) {
        return SiteUrls.workbooksPart() + "/" + params.workbookUrlId + "/history/" + params.revisionNumber;
    };
    SiteUrls.prototype.workbookRevisionHistorySpecificSheetUrl = function (params) {
        return this.fullUrl(this.workbookRevisionHistorySpecificSheetPath(params));
    };
    SiteUrls.prototype.workbookRevisionHistorySpecificSheetPath = function (params) {
        return this.sitePath(SiteUrls.workbookRevisionHistorySpecificSheetPart(params));
    };
    SiteUrls.workbookRevisionHistorySpecificSheetPart = function (params) {
        return SiteUrls.workbooksPart() + "/" + params.workbookUrlId + "/" + params.sheetUrlId + "/history/" + params.revisionNumber;
    };
    SiteUrls.prototype.addUserToDataAlertUrl = function (dataAlertId) {
        return this.fullUrl(this.addUserToDataAlertPath(dataAlertId));
    };
    SiteUrls.prototype.addUserToDataAlertPath = function (dataAlertId) {
        return this.sitePath(SiteUrls.addUserToDataAlertPart(dataAlertId));
    };
    SiteUrls.addUserToDataAlertPart = function (dataAlertId) {
        return "/dataAlert/" + dataAlertId + "/addUser/";
    };
    SiteUrls.prototype.removeUserFromDataAlertUrl = function (dataAlertId) {
        return this.fullUrl(this.removeUserFromDataAlertPath(dataAlertId));
    };
    SiteUrls.prototype.removeUserFromDataAlertPath = function (dataAlertId) {
        return this.sitePath(SiteUrls.removeUserFromDataAlertPart(dataAlertId));
    };
    SiteUrls.removeUserFromDataAlertPart = function (dataAlertId) {
        return "/dataAlert/" + dataAlertId + "/removeUser/";
    };
    SiteUrls.prototype.dataAlertPath = function () {
        return this.sitePath(SiteUrls.dataAlertPart());
    };
    SiteUrls.dataAlertPart = function () {
        return '/dataAlert';
    };
    // Collections
    SiteUrls.prototype.collectionsUrl = function () {
        return this.fullUrl(this.collectionsPath());
    };
    SiteUrls.prototype.collectionsPath = function () {
        return this.sitePath(SiteUrls.collectionsPath());
    };
    SiteUrls.collectionsPath = function () {
        return '/collections';
    };
    SiteUrls.prototype.collectionUrl = function (collectionLuid) {
        return this.fullUrl(this.collectionPath(collectionLuid));
    };
    SiteUrls.prototype.collectionPath = function (collectionLuid) {
        return this.sitePath(SiteUrls.collectionPart(collectionLuid));
    };
    SiteUrls.collectionPart = function (collectionLuid) {
        return SiteUrls.collectionsPath() + "/" + collectionLuid;
    };
    SiteUrls.prototype.redirectToCollectionUrl = function (collectionId, collectionLuid) {
        return this.fullUrl(this.redirectToCollectionPath(collectionId, collectionLuid));
    };
    SiteUrls.prototype.redirectToCollectionPath = function (collectionId, collectionLuid) {
        return this.sitePath(SiteUrls.redirectToCollectionPart(collectionId, collectionLuid));
    };
    SiteUrls.redirectToCollectionPart = function (collectionId, collectionLuid) {
        return "/redirect_to_collection/" + collectionId + "/" + collectionLuid;
    };
    SiteUrls.prototype.allCollectionsUrl = function () {
        return this.fullUrl(this.allCollectionsPath());
    };
    SiteUrls.prototype.allCollectionsPath = function () {
        return this.sitePath(SiteUrls.allCollectionsPart());
    };
    SiteUrls.allCollectionsPart = function () {
        return this.collectionsPath() + "/allCollections";
    };
    SiteUrls.prototype.myCollectionsUrl = function () {
        return this.fullUrl(this.myCollectionsPath());
    };
    SiteUrls.prototype.myCollectionsPath = function () {
        return this.sitePath(SiteUrls.myCollectionsPart());
    };
    SiteUrls.myCollectionsPart = function () {
        return this.collectionsPath() + "/myCollections";
    };
    // VizClient
    // Note that VizClient links do not preserve URL query parameters.
    SiteUrls.prototype.vizClientSitePath = function (path) {
        return "" + this.vizClientSitePrefix + path;
    };
    SiteUrls.makeVizClientSitePrefix = function (siteUrlName) {
        return siteUrlName && siteUrlName.length > 0 ? "/t/" + siteUrlName : '';
    };
    SiteUrls.prototype.newWorkbookUrl = function (projectName) {
        return this.vizClientSitePath("/newWorkbook/" + this.vizClientProjectPart(projectName) + this.generateUniqueAuxiliaryId());
    };
    SiteUrls.prototype.newWorkbookFromDatabase = function (databaseId) {
        return this.newWorkbookUrl() + "?:graphQLDatabaseId=" + databaseId;
    };
    SiteUrls.prototype.newWorkbookFromTable = function (tableId) {
        return this.newWorkbookUrl() + "?:graphQLTableId=" + tableId;
    };
    SiteUrls.prototype.vizClientProjectPart = function (projectName) {
        return projectName && projectName.length > 0 ? "p/" + projectName + "/" : '';
    };
    // Shared with me
    SiteUrls.prototype.sharedWithMeUrl = function () {
        return this.fullUrl(this.sharedWithMePath());
    };
    SiteUrls.prototype.sharedWithMePath = function () {
        return this.sitePath(SiteUrls.sharedWithMePart());
    };
    SiteUrls.sharedWithMePart = function () {
        return '/sharedWithMe';
    };
    // Personal Space
    SiteUrls.prototype.personalSpaceUrl = function () {
        return this.fullUrl(this.personalSpacePath());
    };
    SiteUrls.prototype.personalSpacePath = function () {
        return this.sitePath(SiteUrls.personalSpacePart());
    };
    SiteUrls.personalSpacePart = function () {
        return '/personalSpace';
    };
    // Workbook Acceleration
    SiteUrls.prototype.workbookAccelerationsUrl = function (workbookId) {
        return this.fullUrl(this.workbookAccelerationsPath(workbookId));
    };
    SiteUrls.prototype.workbookAccelerationsPath = function (workbookId) {
        return this.sitePath(SiteUrls.workbookAccelerationsPart(workbookId));
    };
    SiteUrls.workbookAccelerationsPart = function (workbookId) {
        return "" + SiteUrls.workbookPart(workbookId) + SiteUrls.dataAccelerationPart();
    };
    // Starters
    SiteUrls.prototype.startersUrl = function () {
        return this.fullUrl(this.startersPath());
    };
    SiteUrls.prototype.startersPath = function () {
        return this.sitePath(SiteUrls.startersPart());
    };
    SiteUrls.startersPart = function () {
        return '/starters';
    };
    SiteUrls.prototype.startersByConnectionTypeUrl = function (connectionType) {
        return this.fullUrl(this.startersByConnectionTypePath(connectionType));
    };
    SiteUrls.prototype.startersByConnectionTypePath = function (connectionType) {
        return this.sitePath(SiteUrls.startersByConnectionTypePart(connectionType));
    };
    SiteUrls.startersByConnectionTypePart = function (connectionType) {
        return SiteUrls.startersPart() + "/" + connectionType;
    };
    // This code was copied from VizPortal Client and is consumed by at least one other repository.
    // This isn't logically the right place for this sort of logic, but there isn't currently a better place.
    SiteUrls.prototype.generateUniqueAuxiliaryId = function () {
        var base36Digit = function () {
            var s = '0123456789abcdefghijklmnopqrstuvwxyz';
            return s[Math.floor(Math.random() * s.length)];
        };
        var b36 = function (len) {
            var s = '';
            for (var i = 0; i < len; ++i) {
                s += base36Digit();
            }
            return s;
        };
        // To generate the auxiliary ID, use a base-32 encoding of the client time-stamp plus a guid-like base-36 pseudo-unique identifier.
        // We use half the number of digits compared to a standard GUID since base-36 has over twice the number of encoding bits.
        // A collision of identifiers generated in this way is virtually impossible.
        return (new Date()).getTime().toString(32).toLowerCase() + '$' + b36(4) + '-' + b36(2) + '-' + b36(2) + '-' + b36(2) + '-' + b36(6);
    };
    return SiteUrls;
}());
exports.SiteUrls = SiteUrls;
//# sourceMappingURL=SiteUrls.js.map